// Angular Imports
import { OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { saveAs } from 'file-saver';
// App constants
import { appConstants } from '../../app.constant';
// App Services
import { GetAwbDetailsService } from '../../services/get-awb-details.service';
import { GetAwbDocsService } from '../../services/get-awb-docs.service';
import { SubmitInfoService } from '../../services/submit-info.service';
import { LanguageTranslationService } from '../../services/language-translation.service';
import { CommonMethodUtilityService } from '../../services/common-method-utility.service';
import { common } from 'src/environments/common';
import { TranslatePipe } from '../../translate-pipe.pipe';
import { environment } from '../../../environments/environment';
import { FileUploadObjectModel } from '../../models/file-upload-object-model';
import { ReasonCodeStatus } from '../../models/reason-code-status';
// App component
import { AppComponent } from '../../app.component';
import { UserFile } from 'src/app/models/user-file';
import { FileError } from 'src/app/models/file-error';
var getFile = /** @class */ (function () {
    function getFile() {
    }
    return getFile;
}());
export { getFile };
var HS = /** @class */ (function () {
    function HS() {
    }
    return HS;
}());
export { HS };
var CommonReasonCodeComponent = /** @class */ (function () {
    //HS
    function CommonReasonCodeComponent(formBuilder, route, router, awbDetailService, awbDocsService, submitInfoService, languageTranslationService, commonMethodUtilityService, translatePipe, changeDetectorRef, appComponent) {
        this.formBuilder = formBuilder;
        this.route = route;
        this.router = router;
        this.awbDetailService = awbDetailService;
        this.awbDocsService = awbDocsService;
        this.submitInfoService = submitInfoService;
        this.languageTranslationService = languageTranslationService;
        this.commonMethodUtilityService = commonMethodUtilityService;
        this.translatePipe = translatePipe;
        this.changeDetectorRef = changeDetectorRef;
        this.appComponent = appComponent;
        // boolean to indicate if the submit button should be disabled
        this.disableSubmitButton = false;
        // i have no idea what this variable is used for.. :(
        this.fileUploadErrorBoolean = false;
        // a map of reason code(s) for this identifier to their statuses
        this.reasonCodeToStatus = new Map();
        // a list of the reason codes for which information is pending, convenient list instead of iterating above map
        this.pendingReasonCodes = new Array();
        // reason code status expired as sent from the API
        this.reasonCodeStatusExpired = 'RSCODEXP';
        // the statuses we display forms on
        this.statusesToDisplayFormOn = new Set([ReasonCodeStatus.New, ReasonCodeStatus.Completed, ReasonCodeStatus.Error]);
        // a map of reason code(s) to the file upload
        this.reasonCodeToUserFiles = new Map();
        // a list of the reason codes for which information is pending, convenient list instead of iterating above map
        this.acceptedFileTypes = ".pdf,.doc,.docx,.tif,.tiff,.xls,.xlsx,.csv,.jpg,.jpeg,.gif,.png";
        this.isImpnoPrivateShipment = false;
        this.isImpnoPrivateShipmentEligible = false;
        this.redraw = true;
        this.showSubmitDetailsDiv = false;
        this.reasonCodeList = new Array();
        this.countryReasonList = new Array();
        this.valueSeperatedBycomma = "";
        // HS_CODE_TOOL_TIP: string;
        this.UPLOAD_FILE_TOOL_TIP = appConstants.UPLOAD_FILE_TOOL_TIP;
        this.GB_DESCI_URL = common.GB_DESCI_URL;
        this.showApp = false;
        this.expiredRc = false;
        this.showPoaContent = false;
        this.showPoaDontWantOption = false;
        this.showmultipleHSHeader = false;
        this.submitted = false;
        this.showFeedbackMsg = false;
        this.disableSubmitBtnBol = false;
        this.showValidationErrorMsg_DESCI = false;
        this.showValidationErrorMsg_IMPNO_EORI = false;
        this.showValidationErrorMsg_IMPNO_VAT = false;
        this.showValidationErrorMsg_NEORI_EORI = false;
        this.showValidationErrorMsg_NEORI_VAT = false;
        this.showExclamationMark_P1 = false;
        this.showExclamationMark_P2 = false;
        this.showExclamationMark_P3 = false;
        this.showExclamationMark_P4 = false;
        this.showExclamationMark_P5 = false;
        this.showExclamationMark_P6 = false;
        this.showExclamationMark_P7 = false;
        this.showExclamationMark_P8 = false;
        //new reason-code POA//
        this.showExclamationMark_P9 = false;
        //new reason-code POA//
        this.showExclamationMark_P10 = false;
        this.showExclamationMark_P11 = false;
        this.showExclamationMark_P12 = false;
        this.showExclamationMark_P13 = false;
        this.showExclamationMark_P14 = false;
        this.showGreenTickIcon_P1 = false;
        this.showGreenTickIcon_P2 = false;
        this.showGreenTickIcon_P3 = false;
        this.showGreenTickIcon_P4 = false;
        this.showGreenTickIcon_P5 = false;
        this.showGreenTickIcon_P6 = false;
        this.showGreenTickIcon_P7 = false;
        this.showGreenTickIcon_P8 = false;
        //new reason-code POA//
        this.showGreenTickIcon_P9 = false;
        //new reason-code POA//
        this.showGreenTickIcon_P10 = false;
        this.showGreenTickIcon_P11 = false;
        this.showGreenTickIcon_P12 = false;
        this.showGreenTickIcon_P13 = false;
        this.showGreenTickIcon_P14 = false;
        this.showGreenCircleIcon_P1 = false;
        this.showGreenCircleIcon_P2 = false;
        this.showGreenCircleIcon_P3 = false;
        this.showGreenCircleIcon_P4 = false;
        this.showGreenCircleIcon_P5 = false;
        this.showGreenCircleIcon_P6 = false;
        this.showGreenCircleIcon_P7 = false;
        this.showGreenCircleIcon_P8 = false;
        //new reason-code POA//
        this.showGreenCircleIcon_P9 = false;
        //new reason-code POA//
        this.showGreenCircleIcon_P10 = false;
        this.showGreenCircleIcon_P11 = false;
        this.showGreenCircleIcon_P12 = false;
        this.showGreenCircleIcon_P13 = false;
        this.showGreenCircleIcon_P14 = false;
        this.customLoader = false;
        this.keepDefaultSingleOpen = false;
        this.PANEL1_CON_IMPNO_ALLOWED_VALUES = [];
        this.PANEL2_CST_DESCI_ALLOWED_VALUES = [];
        this.PANEL3_CNF_VALUS_ALLOWED_VALUES = [];
        this.PANEL4_DUFR_ALLOWED_VALUES = [];
        this.PANEL5_COR_IMPNO_ALLOWED_VALUES = [];
        this.PANEL6_EXP_ALLOWED_VALUES = [];
        this.PANEL7_INVMS_ALLOWED_VALUES = [];
        this.PANEL8_GNRIC_ALLOWED_VALUES = [];
        //new reason-code POA//
        this.PANEL9_POA_ALLOWED_VALUES = [];
        //new reason-code POA//
        this.PANEL10_NEORI_ALLOWED_VALUES = [];
        this.PANEL11_DEFR_ALLOWED_VALUES = [];
        this.PANEL12_IPRSN_ALLOWED_VALUES = [];
        this.PANEL13_INFOR_ALLOWED_VALUES = [];
        this.PANEL14_MANIC_ALLOWED_VALUES = [];
        this.PANEL1_CON_IMPNO_BOL = false;
        this.PANEL2_CST_DESCI_BOL = false;
        this.PANEL3_CNF_VALUS_BOL = false;
        this.PANEL4_DUFR_BOL = false;
        this.PANEL5_COR_IMPNO_BOL = false;
        this.PANEL6_EXP_BOL = false;
        this.PANEL7_INVMS_BOL = false;
        this.PANEL8_GNRIC_BOL = false;
        //new reason-code POA//
        this.PANEL9_POA_BOL = false;
        this.PANEL9_POA_BOL_DE = false;
        //new reason-code POA//
        this.PANEL10_NEORI_BOL = false;
        this.PANEL10_NEORI_BOL_DE = false;
        this.PANEL11_CON_DEFR_BOL = false;
        this.PANEL12_CON_IPRSN_BOL = false;
        this.PANEL13_INFOR_BOL = false;
        this.PANEL14_CON_MANIC_BOL = false;
        //new reason-code POA//
        this.PANEL9_POA_ALLOWED_VALUES_DE = [];
        //new reason-code POA ZA//
        this.PANEL9_POA_ALLOWED_VALUES_ZA = [];
        //new reason-code POA//
        this.PANEL10_NEORI_ALLOWED_VALUES_DE = [];
        this.DESCI_ALREADY_SUBMITED = false;
        this.IMPNO_CON_ALREADY_SUBMITED = false;
        this.DUFR_ALREADY_SUBMITED = false;
        this.IMPNO_COR_ALREADY_SUBMITED = false;
        this.PFEXP_ALREADY_SUBMITED = false;
        this.INVMS_ALREADY_SUBMITED = false;
        this.GNRIC_ALREADY_SUBMITED = false;
        this.DEFR_CON_ALREADY_SUBMITED = false;
        this.IPRSN_CON_ALREADY_SUBMITED = false;
        this.INFOR_ALREADY_SUBMITED = false;
        this.MANIC_CON_ALREADY_SUBMITED = false;
        //new reason-code POA//
        this.POA_ALREADY_SUBMITED = false;
        //new reason-code POA//
        this.NEORI_ALREADY_SUBMITED = false;
        this.DEFR_ALREADY_SUBMITED = false;
        this.IPRSN_ALREADY_SUBMITED = false;
        //Input box booleans for enabling disabling submit buttons
        this.HS_CODE_DESCI_INPUT_BOL = false;
        this.ITEM_DESC_DESCI_INPUT_BOL = false;
        this.showAwbLink = false;
        this.showCiLink = false;
        this.showECILink = false;
        this.arrayHSCode = [];
        this.arrayHSitem = [];
        //final HS
        this.temp = [];
        this.arrayFileName = [];
        this.tempNeori = [];
        this.arrayFileName1 = [];
        this.arrayFileSrc = [];
        this.tempDufrPH = [];
        this.tempImpnoPH = [];
        this.tempDefr = [];
        this.tempIprsn = [];
        this.tempManic = [];
        this.tempValus = [];
        this.tempDesci = [];
        this.multipleHS = [];
        this.tempPoa = [];
        this.tempGnric = [];
        this.tempInvms = [];
        this.tempInfor = [];
        this.tempPfexp = [];
        this.tempImpno = [];
        this.multipleHSIp = [];
        //HS
        this.HSCde = [{
                harmonizedCode_desci: '',
                itemDescription_desci: ''
            }];
        this.getDocFileArr = new Array();
        this.PANEL1_NA = false;
        this.PANEL2_NA = false;
        this.PANEL3_NA = false;
        this.PANEL4_NA = false;
        this.PANEL5_NA = false;
        this.PANEL6_NA = false;
        this.PANEL7_NA = false;
        this.PANEL8_NA = false;
        this.PANEL9_NA = false;
        //new reason-code POA//
        this.PANEL9_NA_DE = false;
        this.PANEL10_NA = false;
        this.PANEL10_NA_DE = false;
        //DEFR
        this.PANEL11_NA_GB = false;
        //DEFR
        //IPRSN
        this.PANEL12_NA_GB = false;
        //IPRSN
        //INFOR
        this.PANEL13_NA_NL = false;
        //INFOR
        //MANIC
        this.PANEL14_NA_NL = false;
        //file upload;
        this.fileToUpload = new Array();
        this.fileToUploadDufr = null;
        this.fileToUploadValues = null;
        this.fileToUploadImpno = null;
        this.fileToUploadDesci = null;
        this.fileToUploadPfexp = null;
        this.fileToUploadInvms = null;
        this.fileToUploadGnric = null;
        this.fileToUploadDefr = null;
        this.fileToUploadIprsn = null;
        this.fileToUploadInfor = null;
        this.fileToUploadManic = null;
        //new reason-code POA//
        this.fileToUploadPoa = null;
        //new reason-code POA//
        this.fileToUploadNeori = null;
    }
    Object.defineProperty(CommonReasonCodeComponent.prototype, "getReasonCodeFormControls", {
        get: function () {
            return this.reasonCodeForm.controls;
        },
        enumerable: true,
        configurable: true
    });
    //formHS
    CommonReasonCodeComponent.prototype.itemToAdd = function () {
        return this.formBuilder.group({
            harmonizedCode_desci: ['', Validators.pattern('^[0-9 ]*$')],
            itemDescription_desci: ['']
        });
    };
    CommonReasonCodeComponent.prototype.multipleHSEntry = function () {
        console.log("entered");
        this.showmultipleHSHeader = true;
        var addHScode = this.reasonCodeForm.get('multipleHSValues');
        addHScode.push(this.itemToAdd());
    };
    CommonReasonCodeComponent.prototype.removemultipleHSEntry = function (indexToRemove) {
        console.log("remove");
        var addHScode = this.reasonCodeForm.get('multipleHSValues');
        if (indexToRemove > 1) {
            addHScode.removeAt(indexToRemove);
        }
        else if (indexToRemove == 1) {
            addHScode.removeAt(indexToRemove);
            this.showmultipleHSHeader = false;
        }
    };
    //formHS
    CommonReasonCodeComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.disableSubmitBtnBol = true;
        this.applyforEORI = environment.APPLY_EORI_LOCAL_GOVT;
        this.reasonCodeForm = this.formBuilder.group({
            reasonComments_iprsn: ['', Validators.required],
            reasonComments_manic: ['', Validators.required],
            multipleHSValues: this.formBuilder.array([this.itemToAdd()]),
            eori_impno: ['', Validators.pattern('^(?![0-9]*$)(?![a-zA-Z]*$)[a-zA-Z0-9]+$')],
            // this Regex sure does not look correct compared to https://www.oreilly.com/library/view/regular-expressions-cookbook/9781449327453/ch04s21.html
            vat_impno: ['', Validators.pattern('^(?![0-9]*$)(?![a-zA-Z]*$)[a-zA-Z0-9]+$')],
            accNo_defr: ['', Validators.pattern('^[0-9 ]*$')],
            impnoPrivateShipmentCheckBox: [false],
            impnoPrivateShipmentReason: [{ value: '', disabled: true }, Validators.required],
            eori_neori: ['', Validators.pattern('^(?![0-9]*$)(?![a-zA-Z]*$)[a-zA-Z0-9]+$')],
            vat_neori: ['', Validators.pattern('^(?![0-9]*$)(?![a-zA-Z]*$)[a-zA-Z0-9]+$')],
            file_valus: [''],
            file_dufr: [''],
            file_impno: [''],
            file_desci: [''],
            file_pfexp: [''],
            file_invms: [''],
            file_gnric: [''],
            file_defr: [''],
            file_iprsn: [''],
            file_infor: [''],
            file_manic: [''],
            //new reason-code POA//
            file_poa: [''],
            //new reason-code POA// 
            file_neori: [''],
            impnoCommentsNL: [''],
            desciComments: [''],
            valusComments: [''],
            dufrComments: [''],
            impnoCommentsPH: [''],
            pfexpComments: [''],
            invmsComments: [''],
            gnricComments: [''],
            defrComments: [''],
            iprsnComments: [''],
            inforComments: [''],
            manicComments: [''],
            //new reason-code POA//
            poaComments: [''],
            //new reason-code POA// 
            // neoriComments: [''],
            neoriCommentsNL: [''],
            custName: [{ value: '', disabled: true }, Validators.required],
            nameCheckBox: [false],
            reasonCheckBox: [false],
            nameDefrCheckBox: [false],
            custNameDefr: [{ value: '', disabled: true }, Validators.required],
            poaOptionCheckBox: [false],
            poaContentOption: [{ value: '', disabled: true }, Validators.required],
        });
        this.setTermsAndConditionsUrl();
        this.route.paramMap.subscribe(function (params) { _this.uniqueIdForAwb = params.get('uniqueId'); });
        this.oauthToken = environment.API_KEY;
        this.getAwbDetails(this.uniqueIdForAwb, this.oauthToken);
    };
    CommonReasonCodeComponent.prototype.validateDesciForm = function () {
        //multipleHS
        for (var i = 0; i < this.getReasonCodeFormControls.multipleHSValues.value.length; i++) {
            this.multipleHS.push(this.getReasonCodeFormControls.multipleHSValues.value[i]);
            this.arrayHSCode.push(this.getReasonCodeFormControls.multipleHSValues.value[i].harmonizedCode_desci + '_' + "HS" + [i]);
            this.arrayHSitem.push(this.getReasonCodeFormControls.multipleHSValues.value[i].itemDescription_desci + '_' + "HS" + [i]);
        }
        //multipleHS
        if (this.getReasonCodeFormControls.multipleHSValues.errors ||
            this.displayFileSizeErrorDesci || this.displayFileTypeErrorDesci) {
            this.showExclamationMark_P2 = true;
        }
        else {
            this.showExclamationMark_P2 = false;
        }
    };
    //defr
    CommonReasonCodeComponent.prototype.validateDefrForm = function () {
        if (this.getReasonCodeFormControls.accNo_defr.errors || this.displayFileSizeErrorDefr
            || this.displayFileTypeErrorDefr) {
            this.showExclamationMark_P11 = true;
        }
        else if (this.getReasonCodeFormControls.accNo_defr.value.length === 0) {
            this.showExclamationMark_P11 = false;
        }
        else {
            this.showExclamationMark_P11 = false;
        }
    };
    //defr
    //iprsn-GB
    CommonReasonCodeComponent.prototype.validateIprsnForm = function () {
        if (this.getReasonCodeFormControls.reasonComments_iprsn.errors || this.displayFileSizeErrorIprsn
            || this.displayFileTypeErrorIprsn) {
            this.showExclamationMark_P12 = true;
        }
        else if (this.getReasonCodeFormControls.reasonComments_iprsn.value.length === 0) {
            this.showExclamationMark_P12 = false;
        }
        else {
            this.showExclamationMark_P12 = false;
        }
    };
    //iprsn-GB
    //manic-NL
    CommonReasonCodeComponent.prototype.validateManicForm = function () {
        if (this.getReasonCodeFormControls.reasonComments_manic.errors || this.displayFileSizeErrorManic || this.displayFileTypeErrorManic) {
            this.showExclamationMark_P14 = true;
        }
        else if (this.getReasonCodeFormControls.reasonComments_manic.value.length === 0) {
            this.showExclamationMark_P14 = false;
        }
        else {
            this.showExclamationMark_P14 = false;
        }
    };
    //manic-NL
    CommonReasonCodeComponent.prototype.validateNeoriForm = function () {
        if (this.getReasonCodeFormControls.vat_neori.errors || this.getReasonCodeFormControls.eori_neori.errors || this.displayFileSizeErrorNeori
            || this.displayFileTypeErrorNeori) {
            this.showExclamationMark_P10 = true;
        }
        else if (this.getReasonCodeFormControls.vat_neori.value.length === 0 && this.getReasonCodeFormControls.eori_neori.value.length === 0) {
            this.showExclamationMark_P10 = false;
        }
        else {
            this.showExclamationMark_P10 = false;
        }
    };
    CommonReasonCodeComponent.prototype.displayGreenTickIcon = function (panelName) {
        if (panelName === 'PANEL2_CST_DESCI_BOL') {
            if (this.DESCI_ALREADY_SUBMITED) {
                this.showGreenTickIcon_P2 = true;
                return true;
            }
            else if (!this.showExclamationMark_P2 && this.fileToUploadDesci) {
                this.showGreenTickIcon_P2 = true;
                return true;
            }
            else {
                this.showGreenTickIcon_P2 = false;
                return false;
            }
        }
        else if (panelName === 'PANEL1_CON_IMPNO_BOL') {
            if (this.IMPNO_CON_ALREADY_SUBMITED) {
                this.showGreenTickIcon_P1 = true;
                return true;
            }
            else if (!this.showExclamationMark_P1 && (this.getReasonCodeFormControls.eori_impno.value.length > 0 || this.getReasonCodeFormControls.vat_impno.value.length > 0
                || this.getReasonCodeFormControls.impnoCommentsNL.value.length > 0)) {
                this.showGreenTickIcon_P1 = true;
                return true;
            }
            else if (!this.showExclamationMark_P1 && this.fileToUploadImpno && ['DE', 'FR', 'GB', 'NL'].includes(this.country)) {
                this.showGreenTickIcon_P1 = true;
                return true;
            }
            else {
                this.showGreenTickIcon_P1 = false;
                return false;
            }
        }
        //defr-gb
        else if (panelName === 'PANEL11_CON_DEFR_BOL') {
            if (this.DEFR_CON_ALREADY_SUBMITED) {
                this.showGreenTickIcon_P11 = true;
                return true;
            }
            else if (!this.showExclamationMark_P11 && (this.getReasonCodeFormControls.accNo_defr.value.length > 0
                || this.getReasonCodeFormControls.defrComments.value.length > 0)) {
                this.showGreenTickIcon_P11 = true;
                return true;
            }
            else if (!this.showExclamationMark_P11 && this.fileToUploadDefr && this.country === 'GB') {
                this.showGreenTickIcon_P11 = true;
                return true;
            }
            else {
                this.showGreenTickIcon_P11 = false;
                return false;
            }
        }
        //defr-gb
        //iprsn-gb
        else if (panelName === 'PANEL12_CON_IPRSN_BOL') {
            if (this.IPRSN_CON_ALREADY_SUBMITED) {
                this.showGreenTickIcon_P12 = true;
                return true;
            }
            else if (!this.showExclamationMark_P12 && (this.getReasonCodeFormControls.reasonComments_iprsn.value.length > 0
                || this.getReasonCodeFormControls.iprsnComments.value.length > 0)) {
                this.showGreenTickIcon_P12 = true;
                return true;
            }
            else if (!this.showExclamationMark_P12 && this.fileToUploadIprsn && this.country === 'GB') {
                this.showGreenTickIcon_P12 = true;
                return true;
            }
            else {
                this.showGreenTickIcon_P12 = false;
                return false;
            }
        }
        //iprsn-gb
        //manic-nl
        else if (panelName === 'PANEL14_CON_MANIC_BOL') {
            if (this.MANIC_CON_ALREADY_SUBMITED) {
                this.showGreenTickIcon_P14 = true;
                return true;
            }
            else if (!this.showExclamationMark_P14 && (this.getReasonCodeFormControls.reasonComments_manic.value.length > 0
                || this.getReasonCodeFormControls.manicComments.value.length > 0)) {
                this.showGreenTickIcon_P14 = true;
                return true;
            }
            else if (!this.showExclamationMark_P14 && this.fileToUploadManic) {
                this.showGreenTickIcon_P14 = true;
                return true;
            }
            else {
                this.showGreenTickIcon_P14 = false;
                return false;
            }
        }
        //end manic-nl
        else if (panelName === 'PANEL6_EXP_BOL') {
            if (this.PFEXP_ALREADY_SUBMITED) {
                this.showGreenTickIcon_P6 = true;
                return true;
            }
            else if (!this.showExclamationMark_P6 && this.getReasonCodeFormControls.pfexpComments.value.length > 0) {
                this.showGreenTickIcon_P6 = true;
                return true;
            }
            else if (!this.showExclamationMark_P6 && this.fileToUploadPfexp) {
                this.showGreenTickIcon_P6 = true;
                return true;
            }
            else {
                this.showGreenTickIcon_P6 = false;
                return false;
            }
        }
        else if (panelName === 'PANEL7_INVMS_BOL') {
            if (this.INVMS_ALREADY_SUBMITED) {
                this.showGreenTickIcon_P7 = true;
                return true;
            }
            else if (!this.showExclamationMark_P7 && this.getReasonCodeFormControls.invmsComments.value.length > 0) {
                this.showGreenTickIcon_P7 = true;
                return true;
            }
            else if (!this.showExclamationMark_P7 && this.fileToUploadInvms) {
                this.showGreenTickIcon_P7 = true;
                return true;
            }
            else {
                this.showGreenTickIcon_P7 = false;
                return false;
            }
        }
        else if (panelName === 'PANEL8_GNRIC_BOL') {
            if (this.GNRIC_ALREADY_SUBMITED) {
                this.showGreenTickIcon_P8 = true;
                return true;
            }
            else if (!this.showExclamationMark_P8 && this.getReasonCodeFormControls.gnricComments.value.length > 0) {
                this.showGreenTickIcon_P8 = true;
                return true;
            }
            else if (!this.showExclamationMark_P8 && this.fileToUploadGnric) {
                this.showGreenTickIcon_P8 = true;
                return true;
            }
            else {
                this.showGreenTickIcon_P8 = false;
                return false;
            }
        }
        else if (panelName === 'PANEL4_DUFR_BOL') {
            if (this.DUFR_ALREADY_SUBMITED) {
                this.showGreenTickIcon_P4 = true;
                return true;
            }
            else if (!this.showExclamationMark_P4 && this.getReasonCodeFormControls.dufrComments.value.length > 0) {
                this.showGreenTickIcon_P4 = true;
                return true;
            }
            else if (!this.showExclamationMark_P4 && this.fileToUploadDufr) {
                this.showGreenTickIcon_P4 = true;
                return true;
            }
            else {
                this.showGreenTickIcon_P4 = false;
                return false;
            }
        }
        else if (panelName === 'PANEL5_COR_IMPNO_BOL') {
            if (this.IMPNO_COR_ALREADY_SUBMITED) {
                this.showGreenTickIcon_P5 = true;
                return true;
            }
            else if (!this.showExclamationMark_P5 && this.getReasonCodeFormControls.impnoCommentsPH.value.length > 0) {
                this.showGreenTickIcon_P5 = true;
                return true;
            }
            else if (!this.showExclamationMark_P5 && this.fileToUploadImpno && this.country === 'PH') {
                this.showGreenTickIcon_P5 = true;
                return true;
            }
            else {
                this.showGreenTickIcon_P5 = false;
                return false;
            }
        }
        //new reason-code POA//
        else if (panelName === 'PANEL9_POA_BOL' || panelName === 'PANEL9_POA_BOL_DE') {
            if (this.POA_ALREADY_SUBMITED) {
                this.showGreenTickIcon_P9 = true;
                return true;
            }
            else if (!this.showExclamationMark_P9 && this.getReasonCodeFormControls.poaComments.value.length > 0) {
                this.showGreenTickIcon_P9 = true;
                return true;
            }
            else if (!this.showExclamationMark_P9 && this.fileToUploadPoa) {
                this.showGreenTickIcon_P9 = true;
                return true;
            }
            else {
                this.showGreenTickIcon_P9 = false;
                return false;
            }
        }
        //new reason-code POA//
        else if (panelName === 'PANEL10_NEORI_BOL' || panelName === 'PANEL10_NEORI_BOL_DE') {
            if (this.NEORI_ALREADY_SUBMITED) {
                this.showGreenTickIcon_P10 = true;
                return true;
            }
            else if (!this.showExclamationMark_P10 && (this.getReasonCodeFormControls.eori_neori.value.length > 0 || this.getReasonCodeFormControls.vat_neori.value.length > 0
                || this.getReasonCodeFormControls.neoriCommentsNL.value.length > 0)) {
                this.showGreenTickIcon_P10 = true;
                return true;
            }
            else if (!this.showExclamationMark_P10 && this.fileToUploadNeori) {
                this.showGreenTickIcon_P10 = true;
                return true;
            }
            else {
                this.showGreenTickIcon_P10 = false;
                return false;
            }
        }
        //INFOR
        else if (panelName === 'PANEL13_INFOR_BOL') {
            if (this.INFOR_ALREADY_SUBMITED) {
                this.showGreenTickIcon_P13 = true;
                return true;
            }
            else if (!this.showExclamationMark_P13 && this.getReasonCodeFormControls.inforComments.value.length > 0) {
                this.showGreenTickIcon_P13 = true;
                return true;
            }
            else if (!this.showExclamationMark_P13 && this.fileToUploadInfor) {
                this.showGreenTickIcon_P13 = true;
                return true;
            }
            else {
                this.showGreenTickIcon_P13 = false;
                return false;
            }
        }
        //INFOR
    };
    CommonReasonCodeComponent.prototype.displayGreenCircleIcon = function (panelName) {
        if (panelName === 'PANEL1_CON_IMPNO_BOL') {
            if (!this.showGreenTickIcon_P1 && !this.showExclamationMark_P1) {
                this.showGreenCircleIcon_P1 = true;
                return true;
            }
            else {
                this.showGreenCircleIcon_P1 = false;
                return false;
            }
        }
        else if (panelName === 'PANEL11_CON_DEFR_BOL') {
            if (!this.showGreenTickIcon_P11 && !this.showExclamationMark_P11) {
                this.showGreenCircleIcon_P11 = true;
                return true;
            }
            else {
                this.showGreenCircleIcon_P11 = false;
                return false;
            }
        }
        else if (panelName === 'PANEL12_CON_IPRSN_BOL') {
            if (!this.showGreenTickIcon_P12 && !this.showExclamationMark_P12) {
                this.showGreenCircleIcon_P12 = true;
                return true;
            }
            else {
                this.showGreenCircleIcon_P12 = false;
                return false;
            }
        }
        else if (panelName === 'PANEL13_INFOR_BOL') {
            if (!this.showGreenTickIcon_P13 && !this.showExclamationMark_P13) {
                this.showGreenCircleIcon_P13 = true;
                return true;
            }
            else {
                this.showGreenCircleIcon_P13 = false;
                return false;
            }
        }
        else if (panelName === 'PANEL14_CON_MANIC_BOL') {
            if (!this.showGreenTickIcon_P14 && !this.showExclamationMark_P14) {
                this.showGreenCircleIcon_P14 = true;
                return true;
            }
            else {
                this.showGreenCircleIcon_P14 = false;
                return false;
            }
        }
        else if (panelName === 'PANEL2_CST_DESCI_BOL') {
            if (!this.showGreenTickIcon_P2 && !this.showExclamationMark_P2) {
                this.showGreenCircleIcon_P2 = true;
                return true;
            }
            else {
                this.showGreenCircleIcon_P2 = false;
                return false;
            }
        }
        else if (panelName === 'PANEL3_CNF_VALUS_BOL') {
            if (!this.showGreenTickIcon_P3 && !this.showExclamationMark_P3) {
                this.showGreenCircleIcon_P3 = true;
                return true;
            }
            else {
                this.showGreenCircleIcon_P3 = false;
                return false;
            }
        }
        else if (panelName === 'PANEL6_EXP_BOL') {
            if (!this.showGreenTickIcon_P6 && !this.showExclamationMark_P6) {
                this.showGreenCircleIcon_P6 = true;
                return true;
            }
            else {
                this.showGreenCircleIcon_P6 = false;
                return false;
            }
        }
        else if (panelName === 'PANEL7_INVMS_BOL') {
            if (!this.showGreenTickIcon_P7 && !this.showExclamationMark_P7) {
                this.showGreenCircleIcon_P7 = true;
                return true;
            }
            else {
                this.showGreenCircleIcon_P7 = false;
                return false;
            }
        }
        else if (panelName === 'PANEL8_GNRIC_BOL') {
            if (!this.showGreenTickIcon_P8 && !this.showExclamationMark_P8) {
                this.showGreenCircleIcon_P8 = true;
                return true;
            }
            else {
                this.showGreenCircleIcon_P8 = false;
                return false;
            }
        }
        else if (panelName === 'PANEL4_DUFR_BOL') {
            if (!this.showGreenTickIcon_P4 && !this.showExclamationMark_P4) {
                this.showGreenCircleIcon_P4 = true;
                return true;
            }
            else {
                this.showGreenCircleIcon_P4 = false;
                return false;
            }
        }
        else if (panelName === 'PANEL5_COR_IMPNO_BOL') {
            if (!this.showGreenTickIcon_P5 && !this.showExclamationMark_P5) {
                this.showGreenCircleIcon_P5 = true;
                return true;
            }
            else {
                this.showGreenCircleIcon_P5 = false;
                return false;
            }
        }
        //new reason-code POA//
        else if (panelName === 'PANEL9_POA_BOL' || panelName === 'PANEL9_POA_BOL_DE') {
            if (!this.showGreenTickIcon_P9 && !this.showExclamationMark_P9) {
                this.showGreenCircleIcon_P9 = true;
                return true;
            }
            else {
                this.showGreenCircleIcon_P9 = false;
                return false;
            }
        }
        //new reason-code POA//
        else if (panelName === 'PANEL10_NEORI_BOL' || panelName === 'PANEL10_NEORI_BOL_DE') {
            if (!this.showGreenTickIcon_P10 && !this.showExclamationMark_P10) {
                this.showGreenCircleIcon_P10 = true;
                return true;
            }
            else {
                this.showGreenCircleIcon_P10 = false;
                return false;
            }
        }
    };
    CommonReasonCodeComponent.prototype.displayExclamationMarkIcon = function (panelName) {
        if (panelName === 'PANEL1_CON_IMPNO_BOL') {
            if (this.showExclamationMark_P1) {
                return true;
            }
            else {
                return false;
            }
        }
        //defr-Gb
        if (panelName === 'PANEL11_CON_DEFR_BOL') {
            if (this.showExclamationMark_P11) {
                return true;
            }
            else {
                return false;
            }
        }
        //defr-gb
        else if (panelName === 'PANEL2_CST_DESCI_BOL') {
            if (this.showExclamationMark_P2) {
                return true;
            }
            else {
                return false;
            }
        }
        else if (panelName === 'PANEL3_CNF_VALUS_BOL') {
            if (this.showExclamationMark_P3) {
                return true;
            }
            else {
                return false;
            }
        }
        else if (panelName === 'PANEL6_EXP_BOL') {
            if (this.showExclamationMark_P6) {
                return true;
            }
            else {
                return false;
            }
        }
        else if (panelName === 'PANEL7_INVMS_BOL') {
            if (this.showExclamationMark_P7) {
                return true;
            }
            else {
                return false;
            }
        }
        else if (panelName === 'PANEL8_GNRIC_BOL') {
            if (this.showExclamationMark_P8) {
                return true;
            }
            else {
                return false;
            }
        }
        else if (panelName === 'PANEL4_DUFR_BOL') {
            if (this.showExclamationMark_P4) {
                return true;
            }
            else {
                return false;
            }
        }
        else if (panelName === 'PANEL5_COR_IMPNO_BOL') {
            if (this.showExclamationMark_P5) {
                return true;
            }
            else {
                return false;
            }
        }
        //new reason-code POA//
        else if (panelName === 'PANEL9_POA_BOL' || panelName === 'PANEL9_POA_BOL_DE') {
            if (this.showExclamationMark_P9) {
                return true;
            }
            else {
                return false;
            }
        }
        //new reason-code POA//
        else if (panelName === 'PANEL10_NEORI_BOL' || panelName === 'PANEL10_NEORI_BOL_DE') {
            if (this.showExclamationMark_P10) {
                return true;
            }
            else {
                return false;
            }
        }
        //INFOR
        else if (panelName === 'PANEL13_INFOR_BOL') {
            if (this.showExclamationMark_P13) {
                return true;
            }
            else {
                return false;
            }
        }
        //MANIC
        else if (panelName === 'PANEL14_CON_MANIC_BOL') {
            if (this.showExclamationMark_P14) {
                return true;
            }
            else {
                return false;
            }
        }
    };
    CommonReasonCodeComponent.prototype.disableSubmitBtn = function () {
        // the user has not checked the name check box so disable submit
        if (!this.getReasonCodeFormControls.nameCheckBox.value) {
            return true;
        }
        // the customer name is not sufficiently populated so disable the submit button
        if (this.getReasonCodeFormControls.custName.value.length < 1) {
            return true;
        }
        if (common.ROLLED_OUT_COUNTRIES.includes(this.country)) {
            this.disableSubmitBtnBol = this.disableSubmitBtnNL();
            this.disableSubmitBtnBol = this.disableSubmitBtnIE();
        }
        else if (this.country === 'PH') {
            this.disableSubmitBtnBol = this.disableSubmitBtnPH();
        }
        return this.disableSubmitBtnBol;
    };
    CommonReasonCodeComponent.prototype.disableSubmitBtnPH = function () {
        if (!(this.showExclamationMark_P2 || this.showExclamationMark_P3 || this.showExclamationMark_P4
            || this.showExclamationMark_P5)) {
            this.disableSubmitBtnBol = false;
        }
        else {
            this.disableSubmitBtnBol = true;
            if (this.showExclamationMark_P2 || this.showExclamationMark_P3 || this.showExclamationMark_P4
                || this.showExclamationMark_P5) {
                this.disableSubmitBtnBol = true;
            }
            else if (!this.keepDefaultSingleOpen) {
                if (this.showGreenCircleIcon_P2 && this.showGreenCircleIcon_P3 && this.showGreenCircleIcon_P4 && this.showGreenCircleIcon_P5) {
                    this.disableSubmitBtnBol = true;
                }
                else if ((this.showGreenTickIcon_P2 && !this.PANEL2_NA && !this.DESCI_ALREADY_SUBMITED)
                    || (this.isReasonCodeStatusCompleted('VALUS'))
                    || (this.showGreenTickIcon_P4 && !this.PANEL4_NA && !this.DUFR_ALREADY_SUBMITED)
                    || (this.showGreenTickIcon_P5 && !this.PANEL5_NA && !this.IMPNO_COR_ALREADY_SUBMITED)) {
                    this.disableSubmitBtnBol = false;
                }
                else if (this.DESCI_ALREADY_SUBMITED && this.isReasonCodeStatusSubmitted('VALUS') && this.DUFR_ALREADY_SUBMITED && this.IMPNO_COR_ALREADY_SUBMITED) {
                    this.disableSubmitBtnBol = true;
                }
                else if (this.DESCI_ALREADY_SUBMITED && this.PANEL2_CST_DESCI_BOL) {
                    if (this.showExclamationMark_P3 || this.showExclamationMark_P4 || this.showExclamationMark_P5) {
                        this.disableSubmitBtnBol = true;
                    }
                    else if (this.showGreenCircleIcon_P3 && this.showGreenCircleIcon_P4 && this.showGreenCircleIcon_P5) {
                        this.disableSubmitBtnBol = true;
                    }
                    else if (this.PANEL3_NA || this.PANEL4_NA || this.PANEL5_NA) {
                        this.disableSubmitBtnBol = true;
                    }
                    else {
                        this.disableSubmitBtnBol = false;
                    }
                }
                else if (this.isReasonCodeStatusSubmitted('VALUS') && this.PANEL3_CNF_VALUS_BOL) {
                    if (this.showExclamationMark_P2 || this.showExclamationMark_P4 || this.showExclamationMark_P5) {
                        this.disableSubmitBtnBol = true;
                    }
                    else if (this.showGreenCircleIcon_P2 && this.showGreenCircleIcon_P4 && this.showGreenCircleIcon_P5) {
                        this.disableSubmitBtnBol = true;
                    }
                    else if (this.PANEL2_NA || this.PANEL4_NA || this.PANEL5_NA) {
                        this.disableSubmitBtnBol = true;
                    }
                    else {
                        this.disableSubmitBtnBol = false;
                    }
                }
                else if (this.DUFR_ALREADY_SUBMITED && this.PANEL4_DUFR_BOL) {
                    if (this.showExclamationMark_P2 || this.showExclamationMark_P3 || this.showExclamationMark_P5) {
                        this.disableSubmitBtnBol = true;
                    }
                    else if (this.showGreenCircleIcon_P2 && this.showGreenCircleIcon_P3 && this.showGreenCircleIcon_P5) {
                        this.disableSubmitBtnBol = true;
                    }
                    else if (this.PANEL2_NA || this.PANEL3_NA || this.PANEL5_NA) {
                        this.disableSubmitBtnBol = true;
                    }
                    else {
                        this.disableSubmitBtnBol = false;
                    }
                }
                else if (this.IMPNO_COR_ALREADY_SUBMITED && this.PANEL5_COR_IMPNO_BOL) {
                    if (this.showExclamationMark_P2 || this.showExclamationMark_P3 || this.showExclamationMark_P4) {
                        this.disableSubmitBtnBol = true;
                    }
                    else if (this.showGreenCircleIcon_P2 && this.showGreenCircleIcon_P3 && this.showGreenCircleIcon_P4) {
                        this.disableSubmitBtnBol = true;
                    }
                    else if (this.PANEL2_NA || this.PANEL3_NA || this.PANEL4_NA) {
                        this.disableSubmitBtnBol = true;
                    }
                    else {
                        this.disableSubmitBtnBol = false;
                    }
                }
                else if (this.PANEL2_NA || this.PANEL3_NA || this.PANEL4_NA || this.PANEL5_NA) {
                    this.disableSubmitBtnBol = true;
                }
                else {
                    this.disableSubmitBtnBol = false;
                }
            }
            else if (this.keepDefaultSingleOpen) {
                if (this.showExclamationMark_P2 || this.showGreenCircleIcon_P2 || this.DESCI_ALREADY_SUBMITED) {
                    this.disableSubmitBtnBol = true;
                }
                else if (this.showExclamationMark_P3 || this.showGreenCircleIcon_P3 || this.isReasonCodeStatusSubmitted('VALUS')) {
                    this.disableSubmitBtnBol = true;
                }
                else if (this.showExclamationMark_P4 || this.showGreenCircleIcon_P4 || this.DUFR_ALREADY_SUBMITED) {
                    this.disableSubmitBtnBol = true;
                }
                else if (this.showExclamationMark_P5 || this.showGreenCircleIcon_P5 || this.IMPNO_COR_ALREADY_SUBMITED) {
                    this.disableSubmitBtnBol = true;
                }
                else {
                    this.disableSubmitBtnBol = false;
                }
            }
        }
        return this.disableSubmitBtnBol;
    };
    CommonReasonCodeComponent.prototype.disableSubmitBtnNL = function () {
        if (!(this.showExclamationMark_P1 || this.showExclamationMark_P2 || this.showExclamationMark_P3 || this.showExclamationMark_P6 || this.showExclamationMark_P7 || this.showExclamationMark_P8 || this.showExclamationMark_P9 || this.showExclamationMark_P10)) {
            this.disableSubmitBtnBol = false;
        }
        else {
            this.disableSubmitBtnBol = true;
            if (this.showExclamationMark_P1 || this.showExclamationMark_P2 || this.showExclamationMark_P3 || this.showExclamationMark_P6 || this.showExclamationMark_P7 || this.showExclamationMark_P8 || this.showExclamationMark_P9 || this.showExclamationMark_P10) {
                this.disableSubmitBtnBol = true;
            }
            // for default single open = false
            else if (!this.keepDefaultSingleOpen) {
                if (this.showGreenCircleIcon_P1 && this.showGreenCircleIcon_P2 && this.showGreenCircleIcon_P3 && this.showGreenCircleIcon_P6 && this.showGreenCircleIcon_P7 && this.showGreenCircleIcon_P8 && this.showGreenCircleIcon_P9 && this.showGreenCircleIcon_P10) {
                    this.disableSubmitBtnBol = true;
                }
                else if ((this.showGreenTickIcon_P1 && !this.PANEL1_NA && !this.IMPNO_CON_ALREADY_SUBMITED)
                    || (this.showGreenTickIcon_P2 && !this.PANEL2_NA && !this.DESCI_ALREADY_SUBMITED)
                    || this.isReasonCodeStatusCompleted('VALUS')
                    || (this.showGreenTickIcon_P6 && !this.PANEL6_NA && !this.PFEXP_ALREADY_SUBMITED)
                    || (this.showGreenTickIcon_P7 && !this.PANEL7_NA && !this.INVMS_ALREADY_SUBMITED)
                    || (this.showGreenTickIcon_P8 && !this.PANEL8_NA && !this.GNRIC_ALREADY_SUBMITED)
                    //new reason-code POA//
                    || (this.showGreenTickIcon_P9 && !this.PANEL9_NA && !this.POA_ALREADY_SUBMITED)
                    //new reason-code POA//
                    || (this.showGreenTickIcon_P10 && !this.PANEL10_NA && !this.NEORI_ALREADY_SUBMITED)) {
                    this.disableSubmitBtnBol = false;
                }
                else if (this.IMPNO_CON_ALREADY_SUBMITED && this.DESCI_ALREADY_SUBMITED && this.isReasonCodeStatusSubmitted('VALUS') && this.PFEXP_ALREADY_SUBMITED && this.INVMS_ALREADY_SUBMITED && this.GNRIC_ALREADY_SUBMITED && this.POA_ALREADY_SUBMITED && this.NEORI_ALREADY_SUBMITED) {
                    this.disableSubmitBtnBol = true;
                }
                else if (this.IMPNO_CON_ALREADY_SUBMITED && this.PANEL1_CON_IMPNO_BOL) {
                    if (this.showExclamationMark_P2 || this.showExclamationMark_P3 || this.showExclamationMark_P6 || this.showExclamationMark_P7 || this.showExclamationMark_P8 || this.showExclamationMark_P9 || this.showExclamationMark_P10) {
                        this.disableSubmitBtnBol = true;
                    }
                    else if (this.showGreenCircleIcon_P2 && this.showGreenCircleIcon_P3 && this.showGreenCircleIcon_P6 && this.showGreenCircleIcon_P7 && this.showGreenCircleIcon_P8 && this.showGreenCircleIcon_P9 && this.showGreenCircleIcon_P10) {
                        this.disableSubmitBtnBol = true;
                    }
                    else if (this.PANEL2_NA || this.PANEL3_NA || this.PANEL6_NA || this.PANEL7_NA || this.PANEL8_NA || this.PANEL9_NA || this.PANEL10_NA) {
                        this.disableSubmitBtnBol = true;
                    }
                    else {
                        this.disableSubmitBtnBol = false;
                    }
                }
                else if (this.DESCI_ALREADY_SUBMITED && this.PANEL2_CST_DESCI_BOL) {
                    if (this.showExclamationMark_P1 || this.showExclamationMark_P3 || this.showExclamationMark_P6 || this.showExclamationMark_P7 || this.showExclamationMark_P8 || this.showExclamationMark_P9 || this.showExclamationMark_P10) {
                        this.disableSubmitBtnBol = true;
                    }
                    else if (this.showGreenCircleIcon_P1 && this.showGreenCircleIcon_P3 && this.showGreenCircleIcon_P6 && this.showGreenCircleIcon_P7 && this.showGreenCircleIcon_P8 && this.showGreenCircleIcon_P9 && this.showGreenCircleIcon_P10) {
                        this.disableSubmitBtnBol = true;
                    }
                    else if (this.PANEL1_NA || this.PANEL3_NA || this.PANEL6_NA || this.PANEL7_NA || this.PANEL8_NA || this.PANEL9_NA || this.PANEL10_NA) {
                        this.disableSubmitBtnBol = true;
                    }
                    else {
                        this.disableSubmitBtnBol = false;
                    }
                }
                else if (this.isReasonCodeStatusSubmitted('VALUS') && this.PANEL3_CNF_VALUS_BOL) {
                    if (this.showExclamationMark_P1 || this.showExclamationMark_P2 || this.showExclamationMark_P6 || this.showExclamationMark_P7 || this.showExclamationMark_P8 || this.showExclamationMark_P9 || this.showExclamationMark_P10) {
                        this.disableSubmitBtnBol = true;
                    }
                    else if (this.showGreenCircleIcon_P1 && this.showGreenCircleIcon_P2 && this.showGreenCircleIcon_P6 && this.showGreenCircleIcon_P7 && this.showGreenCircleIcon_P8 && this.showGreenCircleIcon_P9 && this.showGreenCircleIcon_P10) {
                        this.disableSubmitBtnBol = true;
                    }
                    else if (this.PANEL1_NA || this.PANEL2_NA || this.PANEL6_NA || this.PANEL7_NA || this.PANEL8_NA || this.PANEL9_NA || this.PANEL10_NA) {
                        this.disableSubmitBtnBol = true;
                    }
                    else {
                        this.disableSubmitBtnBol = false;
                    }
                }
                else if (this.PFEXP_ALREADY_SUBMITED && this.PANEL6_EXP_BOL) {
                    if (this.showExclamationMark_P1 || this.showExclamationMark_P2 || this.showExclamationMark_P3 || this.showExclamationMark_P7 || this.showExclamationMark_P8 || this.showExclamationMark_P9 || this.showExclamationMark_P10) {
                        this.disableSubmitBtnBol = true;
                    }
                    else if (this.showGreenCircleIcon_P1 && this.showGreenCircleIcon_P2 && this.showGreenCircleIcon_P3 && this.showGreenCircleIcon_P7 && this.showGreenCircleIcon_P8 && this.showGreenCircleIcon_P9 && this.showGreenCircleIcon_P10) {
                        this.disableSubmitBtnBol = true;
                    }
                    else if (this.PANEL1_NA || this.PANEL2_NA || this.PANEL3_NA || this.PANEL7_NA || this.PANEL8_NA || this.PANEL9_NA || this.PANEL10_NA) {
                        this.disableSubmitBtnBol = true;
                    }
                    else {
                        this.disableSubmitBtnBol = false;
                    }
                }
                else if (this.INVMS_ALREADY_SUBMITED && this.PANEL7_INVMS_BOL) {
                    if (this.showExclamationMark_P1 || this.showExclamationMark_P2 || this.showExclamationMark_P3 || this.showExclamationMark_P6 || this.showExclamationMark_P8 || this.showExclamationMark_P9 || this.showExclamationMark_P10) {
                        this.disableSubmitBtnBol = true;
                    }
                    else if (this.showGreenCircleIcon_P1 && this.showGreenCircleIcon_P2 && this.showGreenCircleIcon_P3 && this.showGreenCircleIcon_P6 && this.showGreenCircleIcon_P8 && this.showGreenCircleIcon_P9 && this.showGreenCircleIcon_P10) {
                        this.disableSubmitBtnBol = true;
                    }
                    else if (this.PANEL1_NA || this.PANEL2_NA || this.PANEL3_NA || this.PANEL6_NA || this.PANEL8_NA || this.PANEL9_NA || this.PANEL10_NA) {
                        this.disableSubmitBtnBol = true;
                    }
                    else {
                        this.disableSubmitBtnBol = false;
                    }
                }
                else if (this.GNRIC_ALREADY_SUBMITED && this.PANEL8_GNRIC_BOL) {
                    if (this.showExclamationMark_P1 || this.showExclamationMark_P2 || this.showExclamationMark_P3 || this.showExclamationMark_P6 || this.showExclamationMark_P7 || this.showExclamationMark_P9 || this.showExclamationMark_P10) {
                        this.disableSubmitBtnBol = true;
                    }
                    else if (this.showGreenCircleIcon_P1 && this.showGreenCircleIcon_P2 && this.showGreenCircleIcon_P3 && this.showGreenCircleIcon_P6 && this.showGreenCircleIcon_P7 && this.showGreenCircleIcon_P9 && this.showGreenCircleIcon_P10) {
                        this.disableSubmitBtnBol = true;
                    }
                    else if (this.PANEL1_NA || this.PANEL2_NA || this.PANEL3_NA || this.PANEL6_NA || this.PANEL7_NA || this.PANEL9_NA || this.PANEL10_NA) {
                        this.disableSubmitBtnBol = true;
                    }
                    else {
                        this.disableSubmitBtnBol = false;
                    }
                }
                else if (this.POA_ALREADY_SUBMITED && this.PANEL9_POA_BOL) {
                    if (this.showExclamationMark_P1 || this.showExclamationMark_P2 || this.showExclamationMark_P3 || this.showExclamationMark_P6 || this.showExclamationMark_P7 || this.showExclamationMark_P8 || this.showExclamationMark_P10) {
                        this.disableSubmitBtnBol = true;
                    }
                    else if (this.showGreenCircleIcon_P1 && this.showGreenCircleIcon_P2 && this.showGreenCircleIcon_P3 && this.showGreenCircleIcon_P6 && this.showGreenCircleIcon_P7 && this.showGreenCircleIcon_P8 && this.showGreenCircleIcon_P10) {
                        this.disableSubmitBtnBol = true;
                    }
                    else if (this.PANEL1_NA || this.PANEL2_NA || this.PANEL3_NA || this.PANEL6_NA || this.PANEL7_NA || this.PANEL8_NA || this.PANEL10_NA) {
                        this.disableSubmitBtnBol = true;
                    }
                    else {
                        this.disableSubmitBtnBol = false;
                    }
                }
                else if (this.NEORI_ALREADY_SUBMITED && this.PANEL10_NEORI_BOL) {
                    if (this.showExclamationMark_P1 || this.showExclamationMark_P2 || this.showExclamationMark_P3 || this.showExclamationMark_P6 || this.showExclamationMark_P7 || this.showExclamationMark_P8 || this.showExclamationMark_P9) {
                        this.disableSubmitBtnBol = true;
                    }
                    else if (this.showGreenCircleIcon_P1 && this.showGreenCircleIcon_P2 && this.showGreenCircleIcon_P3 && this.showGreenCircleIcon_P6 && this.showGreenCircleIcon_P7 && this.showGreenCircleIcon_P8 && this.showGreenCircleIcon_P9) {
                        this.disableSubmitBtnBol = true;
                    }
                    else if (this.PANEL1_NA || this.PANEL2_NA || this.PANEL3_NA || this.PANEL6_NA || this.PANEL7_NA || this.PANEL8_NA || this.PANEL9_NA) {
                        this.disableSubmitBtnBol = true;
                    }
                    else {
                        this.disableSubmitBtnBol = false;
                    }
                }
                else if (this.PANEL1_NA || this.PANEL2_NA || this.PANEL3_NA || this.PANEL6_NA || this.PANEL7_NA || this.PANEL8_NA || this.PANEL9_NA || this.PANEL10_NA) {
                    this.disableSubmitBtnBol = true;
                }
                else {
                    this.disableSubmitBtnBol = false;
                }
            }
            else if (this.keepDefaultSingleOpen) {
                if (this.showExclamationMark_P1 || this.showGreenCircleIcon_P1 || this.IMPNO_CON_ALREADY_SUBMITED) {
                    this.disableSubmitBtnBol = true;
                }
                else if (this.showExclamationMark_P2 || this.showGreenCircleIcon_P2 || this.DESCI_ALREADY_SUBMITED) {
                    this.disableSubmitBtnBol = true;
                }
                else if (this.showExclamationMark_P3 || this.showGreenCircleIcon_P3 || this.isReasonCodeStatusSubmitted('VALUS')) {
                    this.disableSubmitBtnBol = true;
                }
                else if (this.showExclamationMark_P6 || this.showGreenCircleIcon_P6 || this.PFEXP_ALREADY_SUBMITED) {
                    this.disableSubmitBtnBol = true;
                }
                else if (this.showExclamationMark_P7 || this.showGreenCircleIcon_P7 || this.INVMS_ALREADY_SUBMITED) {
                    this.disableSubmitBtnBol = true;
                }
                else if (this.showExclamationMark_P8 || this.showGreenCircleIcon_P8 || this.GNRIC_ALREADY_SUBMITED) {
                    this.disableSubmitBtnBol = true;
                }
                else if (this.showExclamationMark_P9 || this.showGreenCircleIcon_P9 || this.POA_ALREADY_SUBMITED) {
                    this.disableSubmitBtnBol = true;
                }
                else if (this.showExclamationMark_P10 || this.showGreenCircleIcon_P10 || this.NEORI_ALREADY_SUBMITED) {
                    this.disableSubmitBtnBol = true;
                }
                else {
                    this.disableSubmitBtnBol = false;
                }
            }
        }
        return this.disableSubmitBtnBol;
    };
    CommonReasonCodeComponent.prototype.disableSubmitBtnIE = function () {
        if (!(this.showExclamationMark_P1 || this.showExclamationMark_P2 || this.showExclamationMark_P3 || this.showExclamationMark_P6 || this.showExclamationMark_P7 || this.showExclamationMark_P8 || this.showExclamationMark_P9 || this.showExclamationMark_P10)) {
            this.disableSubmitBtnBol = false;
        }
        else {
            this.disableSubmitBtnBol = true;
            if (this.showExclamationMark_P1 || this.showExclamationMark_P2 || this.showExclamationMark_P3 || this.showExclamationMark_P6 || this.showExclamationMark_P7 || this.showExclamationMark_P8 || this.showExclamationMark_P9 || this.showExclamationMark_P10) {
                this.disableSubmitBtnBol = true;
            }
            // for default single open = false
            else if (!this.keepDefaultSingleOpen) {
                if (this.showGreenCircleIcon_P1 && this.showGreenCircleIcon_P2 && this.showGreenCircleIcon_P3 && this.showGreenCircleIcon_P6 && this.showGreenCircleIcon_P7 && this.showGreenCircleIcon_P8 && this.showGreenCircleIcon_P9 && this.showGreenCircleIcon_P10) {
                    this.disableSubmitBtnBol = true;
                }
                else if ((this.showGreenTickIcon_P1 && !this.PANEL1_NA && !this.IMPNO_CON_ALREADY_SUBMITED)
                    || (this.showGreenTickIcon_P2 && !this.PANEL2_NA && !this.DESCI_ALREADY_SUBMITED)
                    || this.isReasonCodeStatusCompleted('VALUS')
                    || (this.showGreenTickIcon_P6 && !this.PANEL6_NA && !this.PFEXP_ALREADY_SUBMITED)
                    || (this.showGreenTickIcon_P7 && !this.PANEL7_NA && !this.INVMS_ALREADY_SUBMITED)
                    || (this.showGreenTickIcon_P8 && !this.PANEL8_NA && !this.GNRIC_ALREADY_SUBMITED)
                    //new reason-code POA//
                    || (this.showGreenTickIcon_P9 && !this.PANEL9_NA && !this.POA_ALREADY_SUBMITED)
                    //new reason-code POA//
                    || (this.showGreenTickIcon_P10 && !this.PANEL10_NA && !this.NEORI_ALREADY_SUBMITED)) {
                    this.disableSubmitBtnBol = false;
                }
                else if (this.IMPNO_CON_ALREADY_SUBMITED && this.DESCI_ALREADY_SUBMITED && this.isReasonCodeStatusSubmitted('VALUS') && this.PFEXP_ALREADY_SUBMITED && this.INVMS_ALREADY_SUBMITED && this.GNRIC_ALREADY_SUBMITED && this.POA_ALREADY_SUBMITED && this.NEORI_ALREADY_SUBMITED) {
                    this.disableSubmitBtnBol = true;
                }
                else if (this.IMPNO_CON_ALREADY_SUBMITED && this.PANEL1_CON_IMPNO_BOL) {
                    if (this.showExclamationMark_P2 || this.showExclamationMark_P3 || this.showExclamationMark_P6 || this.showExclamationMark_P7 || this.showExclamationMark_P8 || this.showExclamationMark_P9 || this.showExclamationMark_P10) {
                        this.disableSubmitBtnBol = true;
                    }
                    else if (this.showGreenCircleIcon_P2 && this.showGreenCircleIcon_P3 && this.showGreenCircleIcon_P6 && this.showGreenCircleIcon_P7 && this.showGreenCircleIcon_P8 && this.showGreenCircleIcon_P9 && this.showGreenCircleIcon_P10) {
                        this.disableSubmitBtnBol = true;
                    }
                    else if (this.PANEL2_NA || this.PANEL3_NA || this.PANEL6_NA || this.PANEL7_NA || this.PANEL8_NA || this.PANEL9_NA || this.PANEL10_NA) {
                        this.disableSubmitBtnBol = true;
                    }
                    else {
                        this.disableSubmitBtnBol = false;
                    }
                }
                else if (this.DESCI_ALREADY_SUBMITED && this.PANEL2_CST_DESCI_BOL) {
                    if (this.showExclamationMark_P1 || this.showExclamationMark_P3 || this.showExclamationMark_P6 || this.showExclamationMark_P7 || this.showExclamationMark_P8 || this.showExclamationMark_P9 || this.showExclamationMark_P10) {
                        this.disableSubmitBtnBol = true;
                    }
                    else if (this.showGreenCircleIcon_P1 && this.showGreenCircleIcon_P3 && this.showGreenCircleIcon_P6 && this.showGreenCircleIcon_P7 && this.showGreenCircleIcon_P8 && this.showGreenCircleIcon_P9 && this.showGreenCircleIcon_P10) {
                        this.disableSubmitBtnBol = true;
                    }
                    else if (this.PANEL1_NA || this.PANEL3_NA || this.PANEL6_NA || this.PANEL7_NA || this.PANEL8_NA || this.PANEL9_NA || this.PANEL10_NA) {
                        this.disableSubmitBtnBol = true;
                    }
                    else {
                        this.disableSubmitBtnBol = false;
                    }
                }
                else if (this.isReasonCodeStatusSubmitted('VALUS') && this.PANEL3_CNF_VALUS_BOL) {
                    if (this.showExclamationMark_P1 || this.showExclamationMark_P2 || this.showExclamationMark_P6 || this.showExclamationMark_P7 || this.showExclamationMark_P8 || this.showExclamationMark_P9 || this.showExclamationMark_P10) {
                        this.disableSubmitBtnBol = true;
                    }
                    else if (this.showGreenCircleIcon_P1 && this.showGreenCircleIcon_P2 && this.showGreenCircleIcon_P6 && this.showGreenCircleIcon_P7 && this.showGreenCircleIcon_P8 && this.showGreenCircleIcon_P9 && this.showGreenCircleIcon_P10) {
                        this.disableSubmitBtnBol = true;
                    }
                    else if (this.PANEL1_NA || this.PANEL2_NA || this.PANEL6_NA || this.PANEL7_NA || this.PANEL8_NA || this.PANEL9_NA || this.PANEL10_NA) {
                        this.disableSubmitBtnBol = true;
                    }
                    else {
                        this.disableSubmitBtnBol = false;
                    }
                }
                else if (this.PFEXP_ALREADY_SUBMITED && this.PANEL6_EXP_BOL) {
                    if (this.showExclamationMark_P1 || this.showExclamationMark_P2 || this.showExclamationMark_P3 || this.showExclamationMark_P7 || this.showExclamationMark_P8 || this.showExclamationMark_P9 || this.showExclamationMark_P10) {
                        this.disableSubmitBtnBol = true;
                    }
                    else if (this.showGreenCircleIcon_P1 && this.showGreenCircleIcon_P2 && this.showGreenCircleIcon_P3 && this.showGreenCircleIcon_P7 && this.showGreenCircleIcon_P8 && this.showGreenCircleIcon_P9 && this.showGreenCircleIcon_P10) {
                        this.disableSubmitBtnBol = true;
                    }
                    else if (this.PANEL1_NA || this.PANEL2_NA || this.PANEL3_NA || this.PANEL7_NA || this.PANEL8_NA || this.PANEL9_NA || this.PANEL10_NA) {
                        this.disableSubmitBtnBol = true;
                    }
                    else {
                        this.disableSubmitBtnBol = false;
                    }
                }
                else if (this.INVMS_ALREADY_SUBMITED && this.PANEL7_INVMS_BOL) {
                    if (this.showExclamationMark_P1 || this.showExclamationMark_P2 || this.showExclamationMark_P3 || this.showExclamationMark_P6 || this.showExclamationMark_P8 || this.showExclamationMark_P9 || this.showExclamationMark_P10) {
                        this.disableSubmitBtnBol = true;
                    }
                    else if (this.showGreenCircleIcon_P1 && this.showGreenCircleIcon_P2 && this.showGreenCircleIcon_P3 && this.showGreenCircleIcon_P6 && this.showGreenCircleIcon_P8 && this.showGreenCircleIcon_P9 && this.showGreenCircleIcon_P10) {
                        this.disableSubmitBtnBol = true;
                    }
                    else if (this.PANEL1_NA || this.PANEL2_NA || this.PANEL3_NA || this.PANEL6_NA || this.PANEL8_NA || this.PANEL9_NA || this.PANEL10_NA) {
                        this.disableSubmitBtnBol = true;
                    }
                    else {
                        this.disableSubmitBtnBol = false;
                    }
                }
                else if (this.GNRIC_ALREADY_SUBMITED && this.PANEL8_GNRIC_BOL) {
                    if (this.showExclamationMark_P1 || this.showExclamationMark_P2 || this.showExclamationMark_P3 || this.showExclamationMark_P6 || this.showExclamationMark_P7 || this.showExclamationMark_P9 || this.showExclamationMark_P10) {
                        this.disableSubmitBtnBol = true;
                    }
                    else if (this.showGreenCircleIcon_P1 && this.showGreenCircleIcon_P2 && this.showGreenCircleIcon_P3 && this.showGreenCircleIcon_P6 && this.showGreenCircleIcon_P7 && this.showGreenCircleIcon_P9 && this.showGreenCircleIcon_P10) {
                        this.disableSubmitBtnBol = true;
                    }
                    else if (this.PANEL1_NA || this.PANEL2_NA || this.PANEL3_NA || this.PANEL6_NA || this.PANEL7_NA || this.PANEL9_NA || this.PANEL10_NA) {
                        this.disableSubmitBtnBol = true;
                    }
                    else {
                        this.disableSubmitBtnBol = false;
                    }
                }
                else if (this.POA_ALREADY_SUBMITED && this.PANEL9_POA_BOL) {
                    if (this.showExclamationMark_P1 || this.showExclamationMark_P2 || this.showExclamationMark_P3 || this.showExclamationMark_P6 || this.showExclamationMark_P7 || this.showExclamationMark_P8 || this.showExclamationMark_P10) {
                        this.disableSubmitBtnBol = true;
                    }
                    else if (this.showGreenCircleIcon_P1 && this.showGreenCircleIcon_P2 && this.showGreenCircleIcon_P3 && this.showGreenCircleIcon_P6 && this.showGreenCircleIcon_P7 && this.showGreenCircleIcon_P8 && this.showGreenCircleIcon_P10) {
                        this.disableSubmitBtnBol = true;
                    }
                    else if (this.PANEL1_NA || this.PANEL2_NA || this.PANEL3_NA || this.PANEL6_NA || this.PANEL7_NA || this.PANEL8_NA || this.PANEL10_NA) {
                        this.disableSubmitBtnBol = true;
                    }
                    else {
                        this.disableSubmitBtnBol = false;
                    }
                }
                else if (this.NEORI_ALREADY_SUBMITED && this.PANEL10_NEORI_BOL) {
                    if (this.showExclamationMark_P1 || this.showExclamationMark_P2 || this.showExclamationMark_P3 || this.showExclamationMark_P6 || this.showExclamationMark_P7 || this.showExclamationMark_P8 || this.showExclamationMark_P9) {
                        this.disableSubmitBtnBol = true;
                    }
                    else if (this.showGreenCircleIcon_P1 && this.showGreenCircleIcon_P2 && this.showGreenCircleIcon_P3 && this.showGreenCircleIcon_P6 && this.showGreenCircleIcon_P7 && this.showGreenCircleIcon_P8 && this.showGreenCircleIcon_P9) {
                        this.disableSubmitBtnBol = true;
                    }
                    else if (this.PANEL1_NA || this.PANEL2_NA || this.PANEL3_NA || this.PANEL6_NA || this.PANEL7_NA || this.PANEL8_NA || this.PANEL9_NA) {
                        this.disableSubmitBtnBol = true;
                    }
                    else {
                        this.disableSubmitBtnBol = false;
                    }
                }
                else if (this.PANEL1_NA || this.PANEL2_NA || this.PANEL3_NA || this.PANEL6_NA || this.PANEL7_NA || this.PANEL8_NA || this.PANEL9_NA || this.PANEL10_NA) {
                    this.disableSubmitBtnBol = true;
                }
                else {
                    this.disableSubmitBtnBol = false;
                }
            }
            else if (this.keepDefaultSingleOpen) {
                if (this.showExclamationMark_P1 || this.showGreenCircleIcon_P1 || this.IMPNO_CON_ALREADY_SUBMITED) {
                    this.disableSubmitBtnBol = true;
                }
                else if (this.showExclamationMark_P2 || this.showGreenCircleIcon_P2 || this.DESCI_ALREADY_SUBMITED) {
                    this.disableSubmitBtnBol = true;
                }
                else if (this.showExclamationMark_P3 || this.showGreenCircleIcon_P3 || this.isReasonCodeStatusSubmitted('VALUS')) {
                    this.disableSubmitBtnBol = true;
                }
                else if (this.showExclamationMark_P6 || this.showGreenCircleIcon_P6 || this.PFEXP_ALREADY_SUBMITED) {
                    this.disableSubmitBtnBol = true;
                }
                else if (this.showExclamationMark_P7 || this.showGreenCircleIcon_P7 || this.INVMS_ALREADY_SUBMITED) {
                    this.disableSubmitBtnBol = true;
                }
                else if (this.showExclamationMark_P8 || this.showGreenCircleIcon_P8 || this.GNRIC_ALREADY_SUBMITED) {
                    this.disableSubmitBtnBol = true;
                }
                else if (this.showExclamationMark_P9 || this.showGreenCircleIcon_P9 || this.POA_ALREADY_SUBMITED) {
                    this.disableSubmitBtnBol = true;
                }
                else if (this.showExclamationMark_P10 || this.showGreenCircleIcon_P10 || this.NEORI_ALREADY_SUBMITED) {
                    this.disableSubmitBtnBol = true;
                }
                else if (this.showExclamationMark_P13 || this.showGreenCircleIcon_P13 || this.INFOR_ALREADY_SUBMITED) {
                    this.disableSubmitBtnBol = true;
                }
                else {
                    this.disableSubmitBtnBol = false;
                }
            }
        }
        return this.disableSubmitBtnBol;
    };
    CommonReasonCodeComponent.prototype.getAwbDetails = function (uniqueIdForAwb, token) {
        var _this = this;
        this.awbDetailService.getAwbDetails(uniqueIdForAwb, token)
            .subscribe(function (data) {
            if (data) {
                _this.awbNo = data.awb;
                sessionStorage.setItem('awbNo', _this.awbNo);
                _this.getDocuments();
                _this.country = data.country;
                _this.language = data.language;
                _this.setTermsAndConditionsUrl(_this.country, _this.language);
                sessionStorage.setItem('country', _this.country);
                sessionStorage.setItem('language', _this.language);
                _this.languageTranslationService.useLang(_this.language, _this.country);
                _this.appComponent.getLink(_this.language.toLowerCase(), _this.country.toLowerCase());
                _this.TRACKING_URL = environment.TRACKING_URL_PART1 + _this.awbNo + environment.TRACKING_URL_PART2 + 'en_US' + environment.TRACKING_URL_PART3;
                _this.reasonCodeList = data["reason-codes"];
                _this.initializeReasonCodeStatuses(_this.reasonCodeList);
                //DE-POA dont want option
                if (_this.country === 'DE') {
                    if (_this.reasonCodeList.length > 1) {
                        _this.showPoaDontWantOption = true;
                    }
                }
                _this.isImpnoPrivateShipmentEligible = common.IMPNO_PRIVATE_ELIGIBLE_COUNTRIES.includes(_this.country);
                //DE-POA dont want option
                _this.getCountryBasedReassonCode(_this.country, _this.oauthToken);
                if (_this.checkExpiry(_this.reasonCodeList)) {
                    _this.showReasonCodePanels(_this.country, _this.reasonCodeList);
                    _this.checkIfUserNeedsToSubmitDetails();
                    _this.showApp = true;
                }
                _this.setValidation(_this.country);
            }
            else {
                _this.showApp = false;
                _this.errorMsg = _this.translatePipe.transform('INVALID_HYPERLINK_MSG');
            }
        }, function (error) {
            _this.showApp = false;
            _this.errorMsg = _this.commonMethodUtilityService.errorBlockForServiceResponse(error.status);
        });
    };
    CommonReasonCodeComponent.prototype.setValidation = function (country) {
        if (country === 'AE') {
            this.reasonCodeForm.controls["eori_impno"].setValidators([Validators.pattern('^AE-.{1,7}$')]);
            this.reasonCodeForm.controls["vat_impno"].setValidators([Validators.pattern('\\d{15}')]);
        }
        else if (country === 'ZA') {
            this.reasonCodeForm.controls["eori_impno"].clearValidators();
            this.reasonCodeForm.controls["vat_impno"].setValidators([Validators.pattern('^4.{1,9}$')]);
        }
        this.reasonCodeForm.get("eori_impno").updateValueAndValidity();
        this.reasonCodeForm.get("vat_impno").updateValueAndValidity();
    };
    CommonReasonCodeComponent.prototype.checkExpiry = function (reasonCode) {
        var ExpBol = false;
        var expiredCount = 0;
        reasonCode.forEach(function (element) {
            if (element.status === 'RSCODEXP') {
                expiredCount = expiredCount + 1;
            }
        });
        if (expiredCount === reasonCode.length) {
            this.expiredRc = true;
            this.showApp = false;
            ExpBol = false;
        }
        else {
            this.expiredRc = false;
            this.showApp = true;
            ExpBol = true;
        }
        return ExpBol;
    };
    CommonReasonCodeComponent.prototype.getDocuments = function () {
        this.getAWBDocs();
    };
    CommonReasonCodeComponent.prototype.getAWBDocs = function () {
        var _this = this;
        this.awbDocsService.getAWBDocument(this.awbNo)
            .subscribe(function (data) {
            if (_this.isDocumentResponsePopulated(data.awb)) {
                _this.convertToFile(data.awb, 'AWB');
                _this.showAwbLink = true;
            }
            if (_this.isDocumentResponsePopulated(data.eci)) {
                _this.convertToFile(data.eci, 'ECI');
                _this.showECILink = true;
            }
            if (_this.isDocumentResponsePopulated(data.custinv)) {
                _this.convertToFile(data.custinv, 'CI');
                _this.showECILink = true;
            }
        }, function (error) {
            console.log(error);
        });
    };
    CommonReasonCodeComponent.prototype.isDocumentResponsePopulated = function (data) {
        if (typeof data !== 'undefined') {
            return data.properties.StatusCode === 'SUCCESS';
        }
        return false;
    };
    CommonReasonCodeComponent.prototype.getAwb = function () {
        var _this = this;
        this.awbDetailService.getDocument(this.oauthToken, this.awbNo, 'AWB')
            .subscribe(function (data) {
            if (data.properties.StatusCode === 'SUCCESS') {
                _this.convertToFile(data, 'AWB');
                _this.showAwbLink = true;
            }
        }, function (error) {
            console.log(error);
        });
    };
    CommonReasonCodeComponent.prototype.getCi = function () {
        var _this = this;
        this.awbDetailService.getDocument(this.oauthToken, this.awbNo, 'CI')
            .subscribe(function (data) {
            if (data.properties.StatusCode === 'SUCCESS') {
                _this.showCiLink = true;
                _this.convertToFile(data, 'CI');
            }
        }, function (error) {
            console.log(error);
        });
    };
    CommonReasonCodeComponent.prototype.convertToFile = function (data, docType) {
        var blobFileObj;
        var fileName = data.properties.document1.properties.object_name;
        var responseContenType = data.properties.document1.properties.a_content_type; //If the document1 pdf does not get downloaded check for document2
        var fileBytes = data.properties.document1.properties.content;
        var fileExtension = fileName.split('.')[1];
        var decodedStr = atob(fileBytes);
        var byteNumbers = new Array(decodedStr.length);
        for (var i = 0; i < decodedStr.length; i++) {
            byteNumbers[i] = decodedStr.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        blobFileObj = new Blob([byteArray], { type: this.getFileType(fileExtension, responseContenType) });
        var saveDocEle = new getFile();
        saveDocEle.docType = docType;
        saveDocEle.fileName = fileName;
        saveDocEle.fileBlob = blobFileObj;
        this.getDocFileArr.push(saveDocEle);
    };
    CommonReasonCodeComponent.prototype.getFileType = function (fileExtension, responseFileType) {
        var fileType;
        var fileTypeFound = false;
        var standardFileTypeArray = [
            { 'fileExt': 'pdf', 'fileType': 'application/pdf' },
            { 'fileExt': 'doc', 'fileType': 'application/msword' },
            { 'fileExt': 'docx', 'fileType': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' },
            { 'fileExt': 'csv', 'fileType': 'application/vnd.ms-excel' },
            { 'fileExt': 'xls', 'fileType': 'application/vnd.ms-excel' },
            { 'fileExt': 'xlsx', 'fileType': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' },
            { 'fileExt': 'tif', 'fileType': 'image/tiff' },
            { 'fileExt': 'tiff', 'fileType': 'image/tiff' },
            { 'fileExt': 'jpg', 'fileType': 'image/jpeg' },
            { 'fileExt': 'jpeg', 'fileType': 'image/jpeg' },
            { 'fileExt': 'gif', 'fileType': 'image/gif' },
            { 'fileExt': 'png', 'fileType': 'image/png' },
        ];
        var responseFileTypeArray = [
            { 'fileExt': 'tiff', 'fileType': 'image/tiff' },
            { 'fileExt': 'pdf', 'fileType': 'application/pdf' },
        ];
        responseFileTypeArray.forEach(function (element) {
            if (element.fileExt === responseFileType) {
                fileTypeFound = true;
                fileType = element.fileType;
            }
        });
        if (!fileTypeFound) {
            standardFileTypeArray.forEach(function (element) {
                if (element.fileExt === fileExtension) {
                    fileType = element.fileType;
                }
            });
        }
        return fileType;
    };
    CommonReasonCodeComponent.prototype.viewDocs = function (docType) {
        var _this = this;
        this.getDocFileArr.forEach(function (element) {
            if (docType === element.docType) {
                _this.previewFile1(element.fileName, element.fileBlob);
            }
        });
    };
    CommonReasonCodeComponent.prototype.previewFile1 = function (fileName, fileBlob) {
        var fileUrl = URL.createObjectURL(fileBlob);
        var blob;
        if (fileUrl || fileUrl != null) {
            if (window.navigator.msSaveOrOpenBlob) {
                blob = fileBlob;
                window.navigator.msSaveOrOpenBlob(blob, fileName);
            }
            else {
                saveAs(fileBlob, fileName);
            }
        }
    };
    //country config
    CommonReasonCodeComponent.prototype.getCountryBasedReassonCode = function (country, token) {
        var _this = this;
        this.awbDetailService.getCountryBasedReasonDetails(country, token)
            .subscribe(function (data) {
            if (data) {
                _this.countryReasonList = data["records"];
                for (var index = 0; index < _this.countryReasonList.length; index++) {
                    var Country_Reason = country + '_' + _this.countryReasonList[index]["reasonCode"];
                    var panelWithReason = false;
                    if (_this.countryReasonList[index]["reasonCode"] == "IMPNO" && _this.country != 'PH') {
                        _this.PANEL1_CON_IMPNO_ALLOWED_VALUES.push(country + '_' + _this.countryReasonList[index]["reasonCode"]);
                        _this.panelWithReason = true;
                    }
                    else if (_this.countryReasonList[index]["reasonCode"] == "DESCI") {
                        _this.PANEL2_CST_DESCI_ALLOWED_VALUES.push(country + '_' + _this.countryReasonList[index]["reasonCode"]);
                        _this.panelWithReason = true;
                    }
                    else if (_this.countryReasonList[index]["reasonCode"] == "VALUS") {
                        _this.PANEL3_CNF_VALUS_ALLOWED_VALUES.push(country + '_' + _this.countryReasonList[index]["reasonCode"]);
                        _this.panelWithReason = true;
                    }
                    else if (_this.countryReasonList[index]["reasonCode"] == "DUFR") {
                        _this.PANEL4_DUFR_ALLOWED_VALUES.push(country + '_' + _this.countryReasonList[index]["reasonCode"]);
                        _this.panelWithReason = true;
                    }
                    else if (_this.countryReasonList[index]["reasonCode"] == "IMPNO" && _this.country == 'PH') {
                        _this.PANEL5_COR_IMPNO_ALLOWED_VALUES.push(country + '_' + _this.countryReasonList[index]["reasonCode"]);
                        _this.panelWithReason = true;
                    }
                    else if (_this.countryReasonList[index]["reasonCode"] == "PFEXP") {
                        _this.PANEL6_EXP_ALLOWED_VALUES.push(country + '_' + _this.countryReasonList[index]["reasonCode"]);
                        _this.panelWithReason = true;
                    }
                    else if (_this.countryReasonList[index]["reasonCode"] == "INVMS") {
                        _this.PANEL7_INVMS_ALLOWED_VALUES.push(country + '_' + _this.countryReasonList[index]["reasonCode"]);
                        _this.panelWithReason = true;
                    }
                    else if (_this.countryReasonList[index]["reasonCode"] == "GNRIC") {
                        _this.PANEL8_GNRIC_ALLOWED_VALUES.push(country + '_' + _this.countryReasonList[index]["reasonCode"]);
                        _this.panelWithReason = true;
                    }
                    else if (_this.countryReasonList[index]["reasonCode"] == "POA" && _this.country != 'DE') {
                        _this.PANEL9_POA_ALLOWED_VALUES.push(country + '_' + _this.countryReasonList[index]["reasonCode"]);
                        _this.panelWithReason = true;
                    }
                    else if (_this.countryReasonList[index]["reasonCode"] == "EORI" && _this.country != 'DE') {
                        _this.PANEL10_NEORI_ALLOWED_VALUES.push(country + '_' + _this.countryReasonList[index]["reasonCode"]);
                        _this.panelWithReason = true;
                    }
                    else if (_this.countryReasonList[index]["reasonCode"] == "POA" && _this.country == 'DE') {
                        _this.PANEL9_POA_ALLOWED_VALUES_DE.push(country + '_' + _this.countryReasonList[index]["reasonCode"]);
                        _this.panelWithReason = true;
                    }
                    else if (_this.countryReasonList[index]["reasonCode"] == "POA" && _this.country == 'ZA') {
                        _this.PANEL9_POA_ALLOWED_VALUES_ZA.push(country + '_' + _this.countryReasonList[index]["reasonCode"]);
                        _this.panelWithReason = true;
                    }
                    else if (_this.countryReasonList[index]["reasonCode"] == "EORI" && _this.country == 'DE') {
                        _this.PANEL10_NEORI_ALLOWED_VALUES_DE.push(country + '_' + _this.countryReasonList[index]["reasonCode"]);
                        _this.panelWithReason = true;
                    }
                    else if (_this.countryReasonList[index]["reasonCode"] == "DEFR" && _this.country == 'GB') {
                        _this.PANEL11_DEFR_ALLOWED_VALUES.push(country + '_' + _this.countryReasonList[index]["reasonCode"]);
                        _this.panelWithReason = true;
                    }
                    else if (_this.countryReasonList[index]["reasonCode"] == "IPRSN") {
                        _this.PANEL12_IPRSN_ALLOWED_VALUES.push(country + '_' + _this.countryReasonList[index]["reasonCode"]);
                        _this.panelWithReason = true;
                    }
                    else if (_this.countryReasonList[index]["reasonCode"] === "INVOR" && _this.country === 'NL') {
                        _this.PANEL13_INFOR_ALLOWED_VALUES.push(country + '_' + _this.countryReasonList[index]["reasonCode"]);
                        _this.panelWithReason = true;
                    }
                    else if (_this.countryReasonList[index]["reasonCode"] === "MANIC") {
                        _this.PANEL14_MANIC_ALLOWED_VALUES.push(country + '_' + _this.countryReasonList[index]["reasonCode"]);
                        _this.panelWithReason = true;
                    }
                    _this.showReasonCodePanels(_this.country, _this.reasonCodeList);
                }
            }
            else {
                _this.showApp = false;
                _this.errorMsg = _this.translatePipe.transform('INVALID_HYPERLINK_MSG');
            }
        }, function (error) {
            _this.showApp = false;
            _this.errorMsg = _this.commonMethodUtilityService.errorBlockForServiceResponse(error.status);
        });
    };
    //country config
    CommonReasonCodeComponent.prototype.showReasonCodePanels = function (country, reasonCodes) {
        this.keepDefaultSingleOpen = reasonCodes.length === 1;
        for (var index = 0; index < reasonCodes.length; index++) {
            var CTR_RS_STR = country + '_' + reasonCodes[index]["reason-code"];
            this.reasonCode = reasonCodes[index]["reason-code"];
            sessionStorage.setItem('reasonCode', this.reasonCode);
            this.isImpnoEnabled(CTR_RS_STR, reasonCodes[index]);
            this.enable_PANEL2(CTR_RS_STR, reasonCodes[index]);
            this.isValusEnabled(CTR_RS_STR, reasonCodes[index]);
            this.enable_PANEL4(CTR_RS_STR, reasonCodes[index]);
            this.enable_PANEL5(CTR_RS_STR, reasonCodes[index]);
            this.enable_PANEL6(CTR_RS_STR, reasonCodes[index]);
            this.enable_PANEL7(CTR_RS_STR, reasonCodes[index]);
            this.enable_PANEL8(CTR_RS_STR, reasonCodes[index]);
            //new reason-code POA//
            this.enable_PANEL9(CTR_RS_STR, reasonCodes[index]);
            //new reason-code POA//
            this.enable_PANEL10(CTR_RS_STR, reasonCodes[index]);
            //new reason-code POA//
            this.enable_PANEL9_DE(CTR_RS_STR, reasonCodes[index]);
            //new reason-code POA//
            this.enable_PANEL10_DE(CTR_RS_STR, reasonCodes[index]);
            this.enable_PANEL11(CTR_RS_STR, reasonCodes[index]);
            this.enable_PANEL12(CTR_RS_STR, reasonCodes[index]);
            this.enable_PANEL13(CTR_RS_STR, reasonCodes[index]);
            this.enable_PANEL14(CTR_RS_STR, reasonCodes[index]);
        }
    };
    CommonReasonCodeComponent.prototype.submittedCheck = function (RESPONSE_REASON_CODE) {
        if (RESPONSE_REASON_CODE["reason-code"] === 'DESCI' && RESPONSE_REASON_CODE.status === 'SUBMITTED') {
            this.DESCI_ALREADY_SUBMITED = true;
        }
        else if (RESPONSE_REASON_CODE["reason-code"] === 'IMPNO' && (this.country === 'NL' || this.country === 'IE' || this.country === 'FR' || this.country === 'DE') && RESPONSE_REASON_CODE.status === 'SUBMITTED') {
            this.IMPNO_CON_ALREADY_SUBMITED = true;
        }
        else if (RESPONSE_REASON_CODE["reason-code"] === 'IMPNO' && this.country === 'GB' && RESPONSE_REASON_CODE.status === 'SUBMITTED') {
            this.IMPNO_CON_ALREADY_SUBMITED = true;
        }
        else if (RESPONSE_REASON_CODE["reason-code"] === 'PFEXP' && RESPONSE_REASON_CODE.status === 'SUBMITTED') {
            this.PFEXP_ALREADY_SUBMITED = true;
        }
        else if (RESPONSE_REASON_CODE["reason-code"] === 'INVMS' && RESPONSE_REASON_CODE.status === 'SUBMITTED') {
            this.INVMS_ALREADY_SUBMITED = true;
        }
        else if (RESPONSE_REASON_CODE["reason-code"] === 'GNRIC' && RESPONSE_REASON_CODE.status === 'SUBMITTED') {
            this.GNRIC_ALREADY_SUBMITED = true;
        }
        else if (RESPONSE_REASON_CODE["reason-code"] === 'DUFR' && RESPONSE_REASON_CODE.status === 'SUBMITTED') {
            this.DUFR_ALREADY_SUBMITED = true;
        }
        else if (RESPONSE_REASON_CODE["reason-code"] === 'IMPNO' && this.country === 'PH' && RESPONSE_REASON_CODE.status === 'SUBMITTED') {
            this.IMPNO_COR_ALREADY_SUBMITED = true;
        }
        //new reason-code POA//
        else if (RESPONSE_REASON_CODE["reason-code"] === 'POA' && RESPONSE_REASON_CODE.status === 'SUBMITTED') {
            this.POA_ALREADY_SUBMITED = true;
        }
        //new reason-code POA//
        else if (RESPONSE_REASON_CODE["reason-code"] === 'EORI' && RESPONSE_REASON_CODE.status === 'SUBMITTED') {
            this.NEORI_ALREADY_SUBMITED = true;
        }
        else if (RESPONSE_REASON_CODE["reason-code"] === 'DEFR' && RESPONSE_REASON_CODE.status === 'SUBMITTED') {
            this.DEFR_CON_ALREADY_SUBMITED = true;
        }
        else if (RESPONSE_REASON_CODE["reason-code"] === 'IPRSN' && RESPONSE_REASON_CODE.status === 'SUBMITTED') {
            this.IPRSN_CON_ALREADY_SUBMITED = true;
        }
        else if (RESPONSE_REASON_CODE["reason-code"] === 'INFOR' && RESPONSE_REASON_CODE.status === 'SUBMITTED') {
            this.INFOR_ALREADY_SUBMITED = true;
        }
        else if (RESPONSE_REASON_CODE["reason-code"] === 'MANIC' && RESPONSE_REASON_CODE.status === 'SUBMITTED') {
            this.MANIC_CON_ALREADY_SUBMITED = true;
        }
    };
    CommonReasonCodeComponent.prototype.isImpnoEnabled = function (countryReasonCode, reasonCode) {
        var _this = this;
        this.PANEL1_CON_IMPNO_ALLOWED_VALUES.forEach(function (element) {
            if (countryReasonCode === element && reasonCode.status !== _this.reasonCodeStatusExpired) {
                _this.PANEL1_CON_IMPNO_BOL = true;
                _this.submittedCheck(reasonCode);
            }
            if (_this.PANEL1_CON_IMPNO_BOL) {
                _this.PANEL1_NA = false;
            }
            else {
                _this.PANEL1_NA = true;
            }
        });
    };
    CommonReasonCodeComponent.prototype.enable_PANEL2 = function (CTR_RS_STR, RESPONSE_REASON_CODE) {
        for (var index = 0; index < this.PANEL2_CST_DESCI_ALLOWED_VALUES.length; index++) {
            if (CTR_RS_STR === this.PANEL2_CST_DESCI_ALLOWED_VALUES[index] && RESPONSE_REASON_CODE.status !== 'RSCODEXP') {
                this.PANEL2_CST_DESCI_BOL = true;
                this.submittedCheck(RESPONSE_REASON_CODE);
            }
            if (this.PANEL2_CST_DESCI_BOL) {
                this.PANEL2_NA = false;
            }
            else {
                this.PANEL2_NA = true;
            }
        }
    };
    CommonReasonCodeComponent.prototype.isValusEnabled = function (countryReasonCode, reasonCode) {
        var _this = this;
        this.PANEL3_CNF_VALUS_ALLOWED_VALUES.forEach(function (element) {
            if (countryReasonCode === element && reasonCode.status !== _this.reasonCodeStatusExpired) {
                _this.PANEL3_CNF_VALUS_BOL = true;
                _this.submittedCheck(reasonCode);
            }
            if (_this.PANEL3_CNF_VALUS_BOL) {
                _this.PANEL3_NA = false;
            }
            else {
                _this.PANEL3_NA = true;
            }
        });
    };
    CommonReasonCodeComponent.prototype.enable_PANEL4 = function (CTR_RS_STR, RESPONSE_REASON_CODE) {
        for (var index = 0; index < this.PANEL4_DUFR_ALLOWED_VALUES.length; index++) {
            if (CTR_RS_STR === this.PANEL4_DUFR_ALLOWED_VALUES[index] && RESPONSE_REASON_CODE.status !== 'RSCODEXP') {
                this.PANEL4_DUFR_BOL = true;
                this.submittedCheck(RESPONSE_REASON_CODE);
            }
            if (this.PANEL4_DUFR_BOL) {
                this.PANEL4_NA = false;
            }
            else {
                this.PANEL4_NA = true;
            }
        }
    };
    CommonReasonCodeComponent.prototype.enable_PANEL5 = function (CTR_RS_STR, RESPONSE_REASON_CODE) {
        for (var index = 0; index < this.PANEL5_COR_IMPNO_ALLOWED_VALUES.length; index++) {
            if (CTR_RS_STR === this.PANEL5_COR_IMPNO_ALLOWED_VALUES[index] && RESPONSE_REASON_CODE.status !== 'RSCODEXP') {
                this.PANEL5_COR_IMPNO_BOL = true;
                this.submittedCheck(RESPONSE_REASON_CODE);
            }
            if (this.PANEL5_COR_IMPNO_BOL) {
                this.PANEL5_NA = false;
            }
            else {
                this.PANEL5_NA = true;
            }
        }
    };
    CommonReasonCodeComponent.prototype.enable_PANEL6 = function (CTR_RS_STR, RESPONSE_REASON_CODE) {
        for (var index = 0; index < this.PANEL6_EXP_ALLOWED_VALUES.length; index++) {
            if (CTR_RS_STR === this.PANEL6_EXP_ALLOWED_VALUES[index] && RESPONSE_REASON_CODE.status !== 'RSCODEXP') {
                this.PANEL6_EXP_BOL = true;
                this.submittedCheck(RESPONSE_REASON_CODE);
            }
            if (this.PANEL6_EXP_BOL) {
                this.PANEL6_NA = false;
            }
            else {
                this.PANEL6_NA = true;
            }
        }
    };
    CommonReasonCodeComponent.prototype.enable_PANEL7 = function (CTR_RS_STR, RESPONSE_REASON_CODE) {
        for (var index = 0; index < this.PANEL7_INVMS_ALLOWED_VALUES.length; index++) {
            if (CTR_RS_STR === this.PANEL7_INVMS_ALLOWED_VALUES[index] && RESPONSE_REASON_CODE.status !== 'RSCODEXP') {
                this.PANEL7_INVMS_BOL = true;
                this.submittedCheck(RESPONSE_REASON_CODE);
            }
            if (this.PANEL7_INVMS_BOL) {
                this.PANEL7_NA = false;
            }
            else {
                this.PANEL7_NA = true;
            }
        }
    };
    CommonReasonCodeComponent.prototype.enable_PANEL8 = function (CTR_RS_STR, RESPONSE_REASON_CODE) {
        for (var index = 0; index < this.PANEL8_GNRIC_ALLOWED_VALUES.length; index++) {
            if (CTR_RS_STR === this.PANEL8_GNRIC_ALLOWED_VALUES[index] && RESPONSE_REASON_CODE.status !== 'RSCODEXP') {
                this.PANEL8_GNRIC_BOL = true;
                this.submittedCheck(RESPONSE_REASON_CODE);
            }
            if (this.PANEL8_GNRIC_BOL) {
                this.PANEL8_NA = false;
            }
            else {
                this.PANEL8_NA = true;
            }
        }
    };
    CommonReasonCodeComponent.prototype.enable_PANEL9 = function (CTR_RS_STR, RESPONSE_REASON_CODE) {
        for (var index = 0; index < this.PANEL9_POA_ALLOWED_VALUES.length; index++) {
            if (CTR_RS_STR === this.PANEL9_POA_ALLOWED_VALUES[index] && RESPONSE_REASON_CODE.status !== 'RSCODEXP') {
                this.PANEL9_POA_BOL = true;
                this.submittedCheck(RESPONSE_REASON_CODE);
            }
            if (this.PANEL9_POA_BOL) {
                this.PANEL9_NA = false;
            }
            else {
                this.PANEL9_NA = true;
            }
        }
    };
    CommonReasonCodeComponent.prototype.enable_PANEL9_DE = function (CTR_RS_STR, RESPONSE_REASON_CODE) {
        for (var index = 0; index < this.PANEL9_POA_ALLOWED_VALUES_DE.length; index++) {
            if (CTR_RS_STR === this.PANEL9_POA_ALLOWED_VALUES_DE[index] && RESPONSE_REASON_CODE.status !== 'RSCODEXP') {
                this.PANEL9_POA_BOL_DE = true;
                this.submittedCheck(RESPONSE_REASON_CODE);
            }
            if (this.PANEL9_POA_BOL_DE) {
                this.PANEL9_NA_DE = false;
            }
            else {
                this.PANEL9_NA_DE = true;
            }
        }
    };
    CommonReasonCodeComponent.prototype.enable_PANEL10 = function (CTR_RS_STR, RESPONSE_REASON_CODE) {
        for (var index = 0; index < this.PANEL10_NEORI_ALLOWED_VALUES.length; index++) {
            if (CTR_RS_STR === this.PANEL10_NEORI_ALLOWED_VALUES[index] && RESPONSE_REASON_CODE.status !== 'RSCODEXP') {
                this.PANEL10_NEORI_BOL = true;
                this.submittedCheck(RESPONSE_REASON_CODE);
            }
            if (this.PANEL10_NEORI_BOL) {
                this.PANEL10_NA = false;
            }
            else {
                this.PANEL10_NA = true;
            }
        }
    };
    CommonReasonCodeComponent.prototype.enable_PANEL10_DE = function (CTR_RS_STR, RESPONSE_REASON_CODE) {
        for (var index = 0; index < this.PANEL10_NEORI_ALLOWED_VALUES_DE.length; index++) {
            if (CTR_RS_STR === this.PANEL10_NEORI_ALLOWED_VALUES_DE[index] && RESPONSE_REASON_CODE.status !== 'RSCODEXP') {
                this.PANEL10_NEORI_BOL_DE = true;
                this.submittedCheck(RESPONSE_REASON_CODE);
            }
            if (this.PANEL10_NEORI_BOL_DE) {
                this.PANEL10_NA = false;
            }
            else {
                this.PANEL10_NA_DE = true;
            }
        }
    };
    CommonReasonCodeComponent.prototype.enable_PANEL11 = function (CTR_RS_STR, RESPONSE_REASON_CODE) {
        for (var index = 0; index < this.PANEL11_DEFR_ALLOWED_VALUES.length; index++) {
            if (CTR_RS_STR === this.PANEL11_DEFR_ALLOWED_VALUES[index] && RESPONSE_REASON_CODE.status !== 'RSCODEXP') {
                this.PANEL11_CON_DEFR_BOL = true;
                this.submittedCheck(RESPONSE_REASON_CODE);
            }
            if (this.PANEL11_CON_DEFR_BOL) {
                this.PANEL11_NA_GB = false;
            }
            else {
                this.PANEL11_NA_GB = true;
            }
        }
    };
    CommonReasonCodeComponent.prototype.enable_PANEL12 = function (CTR_RS_STR, RESPONSE_REASON_CODE) {
        for (var index = 0; index < this.PANEL12_IPRSN_ALLOWED_VALUES.length; index++) {
            if (CTR_RS_STR === this.PANEL12_IPRSN_ALLOWED_VALUES[index] && RESPONSE_REASON_CODE.status !== 'RSCODEXP') {
                this.PANEL12_CON_IPRSN_BOL = true;
                this.submittedCheck(RESPONSE_REASON_CODE);
            }
            if (this.PANEL12_CON_IPRSN_BOL) {
                this.PANEL12_NA_GB = false;
            }
            else {
                this.PANEL12_NA_GB = true;
            }
        }
    };
    CommonReasonCodeComponent.prototype.enable_PANEL13 = function (CTR_RS_STR, RESPONSE_REASON_CODE) {
        for (var index = 0; index < this.PANEL13_INFOR_ALLOWED_VALUES.length; index++) {
            if (CTR_RS_STR === this.PANEL13_INFOR_ALLOWED_VALUES[index] && RESPONSE_REASON_CODE.status !== 'RSCODEXP') {
                this.PANEL13_INFOR_BOL = true;
                this.submittedCheck(RESPONSE_REASON_CODE);
            }
            if (this.PANEL13_INFOR_BOL) {
                this.PANEL13_NA_NL = false;
            }
            else {
                this.PANEL13_NA_NL = true;
            }
        }
    };
    CommonReasonCodeComponent.prototype.enable_PANEL14 = function (CTR_RS_STR, RESPONSE_REASON_CODE) {
        for (var index = 0; index < this.PANEL14_MANIC_ALLOWED_VALUES.length; index++) {
            if (CTR_RS_STR === this.PANEL14_MANIC_ALLOWED_VALUES[index] && RESPONSE_REASON_CODE.status !== 'RSCODEXP') {
                this.PANEL14_CON_MANIC_BOL = true;
                this.submittedCheck(RESPONSE_REASON_CODE);
            }
            if (this.PANEL14_CON_MANIC_BOL) {
                this.PANEL14_NA_NL = false;
            }
            else {
                this.PANEL14_NA_NL = true;
            }
        }
    };
    //MANIC
    CommonReasonCodeComponent.prototype.submitInfo = function () {
        this.disableSubmit();
        this.submitted = true;
        this.customLoader = true;
        if (this.emptyReasonCodesCheck()) {
            this.showFeedbackMsg = true;
            this.customLoader = false;
            this.feedbackMsg = this.translatePipe.transform('FORM_EMPTY_MSG');
            this.enableSubmit();
        }
        else {
            this.showFeedbackMsg = false;
            this.oauthToken = environment.API_KEY;
            this.validate();
        }
        if (this.getReasonCodeFormControls.valusComments.value !== "") {
            this.reasonCode = "VALUS";
        }
        else if (this.getReasonCodeFormControls.dufrComments.value !== "") {
            this.reasonCode = "DUFR";
        }
        else if (this.getReasonCodeFormControls.desciComments.value !== "") {
            this.reasonCode = "DESCI";
        }
        else if (this.getReasonCodeFormControls.pfexpComments.value !== "") {
            this.reasonCode = "PFEXP";
        }
        else if (this.getReasonCodeFormControls.invmsComments.value !== "") {
            this.reasonCode = "INVMS";
        }
        else if (this.getReasonCodeFormControls.inforComments.value !== "") {
            this.reasonCode = "INFOR";
        }
        else if (this.getReasonCodeFormControls.gnricComments.value !== "") {
            this.reasonCode = "GNRIC";
        }
        else if (this.getReasonCodeFormControls.impnoCommentsNL.value !== "") {
            this.reasonCode = "IMPNO";
        }
        else if (this.getReasonCodeFormControls.eori_impno.value !== "") {
            this.reasonCode = "IMPNO";
        }
        else if (this.getReasonCodeFormControls.vat_impno.value !== "") {
            this.reasonCode = "IMPNO";
        }
        else if (this.getReasonCodeFormControls.impnoCommentsPH.value !== "") {
            this.reasonCode = "IMPNO";
        }
        else if (this.getReasonCodeFormControls.eori_impno.value !== "") {
            this.reasonCode = "IMPNO";
        }
        else if (this.getReasonCodeFormControls.vat_impno.value !== "") {
            this.reasonCode = "IMPNO";
        }
        else if (this.getReasonCodeFormControls.poaComments.value !== "") {
            this.reasonCode = "POA";
        }
        else if (this.getReasonCodeFormControls.neoriCommentsNL.value !== "") {
            this.reasonCode = "EORI";
        }
        else if (this.getReasonCodeFormControls.eori_neori.value !== "") {
            this.reasonCode = "EORI";
        }
        else if (this.getReasonCodeFormControls.vat_neori.value !== "") {
            this.reasonCode = "EORI";
        }
        else if (this.reasonCode == "DEFR" && (this.getReasonCodeFormControls.accNo_defr.value == "")) {
            this.showFeedbackMsg = true;
            this.feedbackMsg = this.translatePipe.transform('DEFR_ACC_ERROR_MSG');
        }
        else if (this.reasonCode == "DEFR" && this.getReasonCodeFormControls.custNameDefr.value == "") {
            this.showFeedbackMsg = true;
            this.feedbackMsg = this.translatePipe.transform('DEFR_CONFIRM_ERROR_MSG');
        }
        else if (this.reasonCode == "IPRSN" && this.getReasonCodeFormControls.reasonComments_iprsn.value == "") {
            this.showFeedbackMsg = true;
            this.feedbackMsg = this.translatePipe.transform('IPRSN_REASON_ERROR_MSG');
        }
        else if (this.getReasonCodeFormControls.reasonComments_iprsn.value !== "") {
            this.reasonCode = "IPRSN";
        }
        else if (this.getReasonCodeFormControls.iprsnComments.value !== "") {
            this.reasonCode = "IPRSN";
        }
        else if (this.reasonCode == "MANIC" && this.getReasonCodeFormControls.reasonComments_manic.value == "") {
            this.showFeedbackMsg = true;
            this.feedbackMsg = this.translatePipe.transform('MANIC_REASON_ERROR_MSG');
        }
        else if (this.getReasonCodeFormControls.reasonComments_manic.value !== "") {
            this.reasonCode = "MANIC";
        }
        else if (this.getReasonCodeFormControls.manicComments.value !== "") {
            this.reasonCode = "MANIC";
        }
    };
    CommonReasonCodeComponent.prototype.emptyReasonCodesCheck = function () {
        var formObj = this.reasonCodeForm.value;
        var disableSubmitBtn = false;
        var eleCount = 0;
        for (var key in formObj) {
            if (formObj.hasOwnProperty(key)) {
                var element = formObj[key];
                if (element && eleCount <= 3) {
                    eleCount = eleCount + 1;
                }
            }
        }
        if (eleCount <= 2) {
            disableSubmitBtn = true;
        }
        return disableSubmitBtn;
    };
    CommonReasonCodeComponent.prototype.checkBoxValue = function () {
        if (this.getReasonCodeFormControls.nameCheckBox.value) {
            this.reasonCodeForm.controls['custName'].enable();
        }
        else {
            this.reasonCodeForm.controls['custName'].disable();
        }
    };
    CommonReasonCodeComponent.prototype.checkBoxValueForDefr = function () {
        if (this.getReasonCodeFormControls.nameDefrCheckBox.value) {
            this.reasonCodeForm.controls['custNameDefr'].enable();
        }
        else {
            this.reasonCodeForm.controls['custNameDefr'].disable();
        }
    };
    //POA-DONT-WANT-OPTION
    CommonReasonCodeComponent.prototype.poaDontWantOptionCheckBoxValue = function () {
        if (this.getReasonCodeFormControls.poaOptionCheckBox.value) {
            this.showPoaContent = true;
        }
        else {
            this.showPoaContent = false;
        }
    };
    CommonReasonCodeComponent.prototype.callUpdateInfoAPI = function () {
        var _this = this;
        var reasonCodeDetailArrayList = this.createReasonCodeObjectArrayList();
        for (var i = 0; i < this.temp.length; i++) {
            this.arrayFileSrc.push(this.temp[i]);
        }
        if (reasonCodeDetailArrayList.length > 0) {
            this.submitInfoService.updateAwbInfo(this.oauthToken, this.uniqueIdForAwb, this.country, reasonCodeDetailArrayList, this.arrayFileSrc)
                .subscribe(function (data) {
                _this.enableSubmit(); // alright the backend service returned lets enable the submit button
                if (!data) {
                    _this.showFeedbackMsg = true;
                    _this.customLoader = false;
                    _this.feedbackMsg = _this.translatePipe.transform('NO_CONTENT_204_MSG');
                }
            }, function (error) {
                _this.enableSubmit(); // hmm something weird came back while invoking the backend service lets enable the submit button
                if (error.status === 200) {
                    _this.router.navigateByUrl('/confirmation');
                    _this.customLoader = false;
                }
                else {
                    _this.showFeedbackMsg = true;
                    _this.customLoader = false;
                    _this.feedbackMsg = _this.commonMethodUtilityService.errorBlockForServiceResponse(error.status);
                }
            });
        }
        else {
            this.enableSubmit(); // hmm the reason code list was not populated (weird) lets enable the submit button
            this.customLoader = false;
            this.showFeedbackMsg = true;
            this.feedbackMsg = this.translatePipe.transform('FORM_EMPTY_MSG');
        }
    };
    CommonReasonCodeComponent.prototype.createReasonCodeObjectArrayList = function () {
        var rcInfoArray = new Array();
        var custName = this.getReasonCodeFormControls.custName.value;
        if (common.ROLLED_OUT_COUNTRIES.includes(this.country)) {
            // did the user complete the imno reason code form?
            if (!this.IMPNO_CON_ALREADY_SUBMITED) {
                var impnoEori = this.getReasonCodeFormControls.eori_impno.value;
                var impnoVat = this.getReasonCodeFormControls.vat_impno.value;
                var impnoComments = this.getReasonCodeFormControls.impnoCommentsNL.value;
                var impnoPrivateReason = this.getReasonCodeFormControls.impnoPrivateShipmentReason.value;
                var impnoPrivate = this.isImpnoPrivateShipmentEligible && this.isImpnoPrivateShipment ? "Yes" : "No";
                if (impnoEori || impnoVat || impnoComments || impnoPrivateReason || this.fileToUploadImpno) {
                    for (var i = 0; i < this.tempImpno.length; i++) {
                        this.arrayFileSrc.push(this.tempImpno[i]);
                        this.arrayFileName.push(this.tempImpno[i].name);
                    }
                    //pvt ship
                    rcInfoArray.push(this.createJsonObjForImpnoNL(impnoEori, impnoVat, impnoComments, custName, impnoPrivateReason, impnoPrivate, this.arrayFileName ? this.arrayFileName.join() : ''));
                }
            }
            if (!this.PFEXP_ALREADY_SUBMITED) {
                var pfexpComments = this.getReasonCodeFormControls.pfexpComments.value;
                if (pfexpComments || this.fileToUploadPfexp) {
                    for (var i = 0; i < this.tempPfexp.length; i++) {
                        this.arrayFileSrc.push(this.tempPfexp[i]);
                        this.arrayFileName.push(this.tempPfexp[i].name);
                    }
                    rcInfoArray.push(this.commonMethodUtilityService.jsonObjForCmntOnlyReasonCode(pfexpComments, custName, 'PFEXP', this.arrayFileName ? this.arrayFileName.join() : ''));
                }
            }
            if (!this.INVMS_ALREADY_SUBMITED) {
                var invmsComments = this.getReasonCodeFormControls.invmsComments.value;
                if (invmsComments || this.fileToUploadInvms) {
                    for (var i = 0; i < this.tempInvms.length; i++) {
                        this.arrayFileSrc.push(this.tempInvms[i]);
                        this.arrayFileName.push(this.tempInvms[i].name);
                    }
                    rcInfoArray.push(this.commonMethodUtilityService.jsonObjForCmntOnlyReasonCode(invmsComments, custName, 'INVMS', this.arrayFileName ? this.arrayFileName.join() : ''));
                }
            }
            //INFOR
            if (!this.INFOR_ALREADY_SUBMITED) {
                var inforComments = this.getReasonCodeFormControls.inforComments.value;
                if (inforComments || this.fileToUploadInfor) {
                    for (var i = 0; i < this.tempInfor.length; i++) {
                        this.arrayFileSrc.push(this.tempInfor[i]);
                        this.arrayFileName.push(this.tempInfor[i].name);
                    }
                    rcInfoArray.push(this.commonMethodUtilityService.jsonObjForCmntOnlyReasonCode(inforComments, custName, CommonReasonCodeComponent.REASON_CODE_INVOR, this.arrayFileName ? this.arrayFileName.join() : ''));
                }
            }
            //INFOR
            if (!this.GNRIC_ALREADY_SUBMITED) {
                var gnricComments = this.getReasonCodeFormControls.gnricComments.value;
                if (gnricComments || this.fileToUploadGnric) {
                    for (var i = 0; i < this.tempGnric.length; i++) {
                        this.arrayFileSrc.push(this.tempGnric[i]);
                        this.arrayFileName.push(this.tempGnric[i].name);
                    }
                    rcInfoArray.push(this.commonMethodUtilityService.jsonObjForCmntOnlyReasonCode(gnricComments, custName, 'GNRIC', this.arrayFileName ? this.arrayFileName.join() : ''));
                }
            }
        }
        //new reason-code POA//
        if (!this.POA_ALREADY_SUBMITED) {
            var poaComments = this.getReasonCodeFormControls.poaComments.value;
            var isPOAEnabled = this.showPoaContent ? "Yes" : "No";
            if (poaComments || this.fileToUploadPoa) {
                for (var i = 0; i < this.tempPoa.length; i++) {
                    this.arrayFileSrc.push(this.tempPoa[i]);
                    this.arrayFileName.push(this.tempPoa[i].name);
                }
                rcInfoArray.push(this.commonMethodUtilityService.jsonObjForPOAReasonCode(poaComments, isPOAEnabled, custName, 'POA', this.arrayFileName ? this.arrayFileName.join() : ''));
            }
        }
        //new reason-code POA//
        if (!this.NEORI_ALREADY_SUBMITED) {
            var eori_Neori = this.getReasonCodeFormControls.eori_neori.value;
            var vat_Neori = this.getReasonCodeFormControls.vat_neori.value;
            var comments_Neori = this.getReasonCodeFormControls.neoriCommentsNL.value;
            if (eori_Neori || vat_Neori || comments_Neori || this.fileToUploadNeori) {
                for (var i = 0; i < this.tempNeori.length; i++) {
                    this.arrayFileSrc.push(this.tempNeori[i]);
                    this.arrayFileName.push(this.tempNeori[i].name);
                }
                rcInfoArray.push(this.createJsonObjForNeoriNL(eori_Neori, vat_Neori, comments_Neori, custName, this.arrayFileName ? this.arrayFileName.join() : ''));
            }
        }
        if (!this.DEFR_ALREADY_SUBMITED) {
            var accNo_defr = this.getReasonCodeFormControls.accNo_defr.value;
            var comments_defr = this.getReasonCodeFormControls.defrComments.value;
            var custNameDefr = this.getReasonCodeFormControls.custNameDefr.value;
            if (accNo_defr && custNameDefr) {
                for (var i = 0; i < this.tempDefr.length; i++) {
                    this.arrayFileSrc.push(this.tempDefr[i]);
                    this.arrayFileName.push(this.tempDefr[i].name);
                }
                rcInfoArray.push(this.createJsonObjForDefr(accNo_defr, custNameDefr, comments_defr, custName, this.arrayFileName ? this.arrayFileName.join() : ''));
            }
        }
        //IPRSN
        if (!this.IPRSN_ALREADY_SUBMITED) {
            var reasonComments_iprsn = this.getReasonCodeFormControls.reasonComments_iprsn.value;
            var comments_iprsn = this.getReasonCodeFormControls.iprsnComments.value;
            if (reasonComments_iprsn) {
                for (var i = 0; i < this.tempIprsn.length; i++) {
                    this.arrayFileSrc.push(this.tempIprsn[i]);
                    this.arrayFileName.push(this.tempIprsn[i].name);
                }
                rcInfoArray.push(this.createJsonObjForIprsn(reasonComments_iprsn, comments_iprsn, custName, this.arrayFileName ? this.arrayFileName.join() : ''));
            }
        }
        //IPRSN
        //MANIC
        if (!this.MANIC_CON_ALREADY_SUBMITED) {
            var reasonComments_manic = this.getReasonCodeFormControls.reasonComments_manic.value;
            var comments_manic = this.getReasonCodeFormControls.manicComments.value;
            if (reasonComments_manic) {
                for (var i = 0; i < this.tempManic.length; i++) {
                    this.arrayFileSrc.push(this.tempManic[i]);
                    this.arrayFileName.push(this.tempManic[i].name);
                }
                rcInfoArray.push(this.createJsonObjForManic(reasonComments_manic, comments_manic, custName, this.arrayFileName ? this.arrayFileName.join() : ''));
            }
        }
        // Reason codes MANIC and DESCI
        if (!this.DESCI_ALREADY_SUBMITED) {
            //multipleHS
            for (var _i = 0, _a = this.getReasonCodeFormControls.multipleHSValues.value; _i < _a.length; _i++) {
                var harmonizedCodes = _a[_i];
                this.multipleHS.push(harmonizedCodes);
            }
            var hsCode_Desci = this.arrayHSCode.toString();
            var itemDescription_Desci = this.arrayHSitem.toString();
            //multipleHS
            var desciComments = this.getReasonCodeFormControls.desciComments.value;
            if (hsCode_Desci || itemDescription_Desci || desciComments || this.fileToUploadDesci) {
                for (var i = 0; i < this.tempDesci.length; i++) {
                    this.arrayFileSrc.push(this.tempDesci[i]);
                    this.arrayFileName.push(this.tempDesci[i].name);
                }
                rcInfoArray.push(this.createJsonObjForDesci(hsCode_Desci, itemDescription_Desci, desciComments, custName, this.arrayFileName ? this.arrayFileName.join() : ''));
            }
        }
        if (this.isReasonCodeStatusCompleted(CommonReasonCodeComponent.REASON_CODE_VALUS)) {
            var valusComments = this.getReasonCodeFormControls.valusComments.value;
            if (valusComments || this.fileToUploadValues) {
                for (var i = 0; i < this.tempValus.length; i++) {
                    this.arrayFileSrc.push(this.tempValus[i]);
                    this.arrayFileName.push(this.tempValus[i].name);
                }
                rcInfoArray.push(this.commonMethodUtilityService.jsonObjForCmntOnlyReasonCode(valusComments, custName, 'VALUS', this.arrayFileName ? this.arrayFileName.join() : ''));
            }
        }
        if (this.country === 'PH') {
            if (!this.DUFR_ALREADY_SUBMITED) {
                var dufrComments = this.getReasonCodeFormControls.dufrComments.value;
                if (dufrComments || this.fileToUploadDufr) {
                    for (var i = 0; i < this.tempDufrPH.length; i++) {
                        this.arrayFileSrc.push(this.tempDufrPH[i]);
                        this.arrayFileName.push(this.tempDufrPH[i].name);
                    }
                    rcInfoArray.push(this.commonMethodUtilityService.jsonObjForCmntOnlyReasonCode(dufrComments, custName, 'DUFR', this.arrayFileName ? this.arrayFileName.join() : ''));
                }
            }
            if (!this.IMPNO_COR_ALREADY_SUBMITED) {
                var impnoCommentsPH = this.getReasonCodeFormControls.impnoCommentsPH.value;
                if (impnoCommentsPH || this.fileToUploadImpno) {
                    for (var i = 0; i < this.tempImpnoPH.length; i++) {
                        this.arrayFileSrc.push(this.tempImpnoPH[i]);
                        this.arrayFileName.push(this.tempImpnoPH[i].name);
                    }
                    rcInfoArray.push(this.commonMethodUtilityService.jsonObjForCmntOnlyReasonCode(impnoCommentsPH, custName, 'IMPNO', this.arrayFileName ? this.arrayFileName.join() : ''));
                }
            }
        }
        return rcInfoArray;
    };
    CommonReasonCodeComponent.prototype.createJsonObjForImpnoNL = function (eoriInput, vatInput, commentsInput, custName, privateReason, isPrivate, fileName) {
        var impno_Obj = {};
        var eoriKey = 'EORI No';
        var eoriValue = eoriInput;
        var vatKey = 'Vat No';
        var vatValue = vatInput;
        var commentKey = 'Comments';
        var commentValue = commentsInput;
        var custNameKey = 'Customer Name';
        var custNameValue = custName;
        var isPrivateShipmentkey = 'isPrivateShipment';
        var isPrivateShipValue = isPrivate;
        var pvtReasonKey = 'Reason';
        var pvtReasonValue = privateReason;
        var detailsValue = {};
        if (eoriValue != "") {
            detailsValue[eoriKey] = eoriValue;
        }
        if (vatValue != "") {
            detailsValue[vatKey] = vatValue;
        }
        detailsValue[commentKey] = commentValue;
        detailsValue[custNameKey] = custNameValue;
        detailsValue[pvtReasonKey] = pvtReasonValue;
        detailsValue[isPrivateShipmentkey] = isPrivateShipValue;
        detailsValue['Files'] = fileName;
        impno_Obj[CommonReasonCodeComponent.RC_CODE] = CommonReasonCodeComponent.REASON_CODE_IMPNO;
        impno_Obj[CommonReasonCodeComponent.DETAILS] = detailsValue;
        return impno_Obj;
    };
    CommonReasonCodeComponent.prototype.createJsonObjForNeoriNL = function (eoriInput, vatInput, commentsInput, custName, fileName) {
        var neori_Obj = {};
        var codeKey = 'rc_code';
        var codeValue = 'EORI';
        var eoriKey = 'EORI No';
        var eoriValue = eoriInput;
        var vatKey = 'Vat No';
        var vatValue = vatInput;
        var commentKey = 'Comments';
        var commentValue = commentsInput;
        var custNameKey = 'Customer Name';
        var custNameValue = custName;
        var detailsKey = 'details';
        var detailsValue = {};
        detailsValue[eoriKey] = eoriValue;
        detailsValue[vatKey] = vatValue;
        detailsValue[commentKey] = commentValue;
        detailsValue[custNameKey] = custNameValue;
        detailsValue['Files'] = fileName;
        neori_Obj[codeKey] = codeValue;
        neori_Obj[detailsKey] = detailsValue;
        return neori_Obj;
    };
    //DEFR
    CommonReasonCodeComponent.prototype.createJsonObjForDefr = function (defrInput, custDefrName, commentsInput, custName, fileName) {
        var defr_Obj = {};
        var codeKey = 'rc_code';
        var codeValue = 'DEFR';
        var defrAccKey = 'Acc No';
        var defrAccValue = defrInput;
        var custDefrNameKey = 'Customer DEFR Name';
        var custDefrNameValue = custDefrName;
        var commentKey = 'Comments';
        var commentValue = commentsInput;
        var custNameKey = 'Customer Name';
        var custNameValue = custName;
        var detailsKey = 'details';
        var detailsValue = {};
        detailsValue[defrAccKey] = defrAccValue;
        detailsValue[custDefrNameKey] = custDefrNameValue;
        detailsValue[commentKey] = commentValue;
        detailsValue[custNameKey] = custNameValue;
        detailsValue['Files'] = fileName;
        defr_Obj[codeKey] = codeValue;
        defr_Obj[detailsKey] = detailsValue;
        return defr_Obj;
    };
    // Reason codes DEFR IPRSN DEFR
    CommonReasonCodeComponent.prototype.createJsonObjForIprsn = function (reasonComments_iprsnInput, commentsInput, custName, fileName) {
        var iprsn_Obj = {};
        var codeKey = 'rc_code';
        var codeValue = 'IPRSN';
        var iprsnReasonKey = 'Add Reason for goods';
        var iprsnReasonValue = reasonComments_iprsnInput;
        var commentKey = 'Comments';
        var commentValue = commentsInput;
        var custNameKey = 'Customer Name';
        var custNameValue = custName;
        var detailsKey = 'details';
        var detailsValue = {};
        detailsValue[iprsnReasonKey] = iprsnReasonValue;
        detailsValue[commentKey] = commentValue;
        detailsValue[custNameKey] = custNameValue;
        detailsValue['Files'] = fileName;
        iprsn_Obj[codeKey] = codeValue;
        iprsn_Obj[detailsKey] = detailsValue;
        return iprsn_Obj;
    };
    //end IPRSN
    //begin MANIC
    CommonReasonCodeComponent.prototype.createJsonObjForManic = function (reasonComments_manicInput, commentsInput, custName, fileName) {
        var manic_Obj = {};
        var manicReasonKey = 'Add Reason for manic';
        var manicReasonValue = reasonComments_manicInput;
        var commentKey = 'Comments';
        var commentValue = commentsInput;
        var custNameKey = 'Customer Name';
        var custNameValue = custName;
        var detailsValue = {};
        detailsValue[manicReasonKey] = manicReasonValue;
        detailsValue[commentKey] = commentValue;
        detailsValue[custNameKey] = custNameValue;
        detailsValue['Files'] = fileName;
        manic_Obj[CommonReasonCodeComponent.RC_CODE] = CommonReasonCodeComponent.REASON_CODE_MANIC;
        manic_Obj[CommonReasonCodeComponent.DETAILS] = detailsValue;
        return manic_Obj;
    };
    //end MANIC
    CommonReasonCodeComponent.prototype.createJsonObjForDesci = function (hsCodeInput, itemDescInput, commentsInput, custName, fileName) {
        var desci_Obj = {};
        var hsCodeKey = 'Harmonized Code';
        var hsCodeValue = hsCodeInput;
        var itemDescrKey = 'Item Description';
        var itemDescrValue = itemDescInput;
        var commentKey = 'Comments';
        var commentValue = commentsInput;
        var custNameKey = 'Customer Name';
        var custNameValue = custName;
        var detailsValue = {};
        detailsValue[hsCodeKey] = hsCodeValue;
        detailsValue[itemDescrKey] = itemDescrValue;
        detailsValue[commentKey] = commentValue;
        detailsValue[custNameKey] = custNameValue;
        detailsValue['Files'] = fileName;
        desci_Obj[CommonReasonCodeComponent.RC_CODE] = CommonReasonCodeComponent.REASON_CODE_DESCI;
        desci_Obj[CommonReasonCodeComponent.DETAILS] = detailsValue;
        return desci_Obj;
    };
    CommonReasonCodeComponent.prototype.getFormattedDate = function () {
        var createDate = new Date();
        var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        return createDate.getDate() + "-" + monthNames[createDate.getMonth()] + "-" + createDate.getFullYear();
    };
    CommonReasonCodeComponent.prototype.addJsToElement = function (src) {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = src;
        document.getElementsByTagName('body')[0].appendChild(script);
        return script;
    };
    CommonReasonCodeComponent.prototype.validate = function () {
        // Check to see if the customer name has been popoulated before we submit the form
        if (!this.isCustomerNamePopulated()) {
            return;
        }
        if (this.fileToUpload.length > 0) {
            this.readFileArray();
        }
        this.callUpdateInfoAPI();
    };
    CommonReasonCodeComponent.prototype.readFileArray = function () {
        this.fileUploadErrorBoolean = false;
    };
    CommonReasonCodeComponent.prototype.doesReasonCodeExist = function (reasonCode) {
        var reasonCodeExist = false;
        for (var index = 0; index < this.fileToUpload.length; index++) {
            if (this.fileToUpload[index].reasonCode === reasonCode) {
                reasonCodeExist = true;
            }
        }
        return reasonCodeExist;
    };
    CommonReasonCodeComponent.prototype.handleFileInput = function (event, val, UiMode) {
        if (val === "dufr") {
            if (event.target.files) {
                var filesAmount = event.target.files.length;
                for (var i = 0; i < filesAmount; i++) {
                    if (this.tempDufrPH.length < 5) {
                        this.tempDufrPH.push(event.target.files[i]);
                    }
                }
            }
            if (UiMode) {
                this.reasonCodeForm.get('file_dufr').setValue(event.target.files.item(0));
            }
            this.fileToUploadDufr = this.reasonCodeForm.get('file_dufr').value;
            this.fileNameDufr = this.fileToUploadDufr.name;
            var isSizeValid = this.commonMethodUtilityService.validateFileSize(this.fileToUploadDufr);
            var isFileTypeValid = this.commonMethodUtilityService.validateFileType(this.fileToUploadDufr);
            this.dufrValid = isFileTypeValid;
            if (isSizeValid) {
                this.displayFileSizeErrorDufr = false;
                if (this.dufrValid) {
                    this.fileName = this.fileNameDufr;
                    this.displayFileTypeErrorDufr = false;
                    this.displayFileSizeErrorDufr = false;
                    if (this.doesReasonCodeExist('DUFR')) {
                        this.removeFileFromUploadArray('DUFR');
                    }
                    this.fileToUpload.push(new FileUploadObjectModel('DUFR', this.fileToUploadDufr));
                    this.displayFileTypeErrorDufr = false;
                    this.displayFileSizeErrorDufr = false;
                    this.showExclamationMark_P4 = false;
                    this.showGreenTickIcon_P4 = true;
                }
                else {
                    this.validateFiles = true;
                    this.showExclamationMark_P4 = true;
                    this.showGreenTickIcon_P4 = false;
                    this.displayFileTypeErrorDufr = true;
                    this.displayFileSizeErrorDufr = false;
                }
            }
            else {
                this.showExclamationMark_P4 = true;
                this.showGreenTickIcon_P4 = false;
                this.displayFileSizeErrorDufr = true;
                this.displayFileTypeErrorDufr = false;
            }
        }
        else if (val === "desci") {
            if (event.target.files) {
                var filesAmount = event.target.files.length;
                for (var i = 0; i < filesAmount; i++) {
                    if (this.tempDesci.length < 5) {
                        this.tempDesci.push(event.target.files[i]);
                    }
                }
            }
            if (UiMode) {
                this.reasonCodeForm.get('file_desci').setValue(event.target.files.item(0));
            }
            this.fileToUploadDesci = this.reasonCodeForm.get('file_desci').value;
            this.fileNameDesci = this.fileToUploadDesci.name;
            var isSizeValid = this.commonMethodUtilityService.validateFileSize(this.fileToUploadDesci);
            var isFileTypeValid = this.commonMethodUtilityService.validateFileType(this.fileToUploadDesci);
            this.desciValid = isFileTypeValid;
            if (isSizeValid) {
                this.displayFileSizeErrorDesci = false;
                if (this.desciValid) {
                    this.fileName = this.fileNameDesci;
                    this.displayFileTypeErrorDesci = false;
                    if (this.doesReasonCodeExist('DESCI')) {
                        this.removeFileFromUploadArray('DESCI');
                    }
                    this.fileToUpload.push(new FileUploadObjectModel('DESCI', this.fileToUploadDesci));
                    this.displayFileTypeErrorDesci = false;
                    this.showExclamationMark_P2 = false;
                    this.showGreenTickIcon_P2 = true;
                    this.validateDesciForm();
                }
                else {
                    this.validateFiles = true;
                    this.showExclamationMark_P2 = true;
                    this.showGreenTickIcon_P2 = false;
                    this.displayFileTypeErrorDesci = true;
                    this.displayFileSizeErrorDesci = false;
                }
            }
            else {
                this.showExclamationMark_P2 = true;
                this.showGreenTickIcon_P2 = false;
                this.displayFileSizeErrorDesci = true;
                this.displayFileTypeErrorDesci = false;
            }
        }
        else if (val === "values") {
            if (event.target.files) {
                var filesAmount = event.target.files.length;
                for (var i = 0; i < filesAmount; i++) {
                    if (this.tempValus.length < 5) {
                        this.tempValus.push(event.target.files[i]);
                    }
                }
            }
            if (UiMode) {
                this.reasonCodeForm.get('file_valus').setValue(event.target.files.item(0));
            }
            this.fileToUploadValues = this.reasonCodeForm.get('file_valus').value;
            this.fileNameValues = this.fileToUploadValues.name;
            var isSizeValid = this.commonMethodUtilityService.validateFileSize(this.fileToUploadValues);
            var isFileTypeValid = this.commonMethodUtilityService.validateFileType(this.fileToUploadValues);
            this.valuesValid = isFileTypeValid;
            if (isSizeValid) {
                this.displayFileSizeErrorValues = false;
                if (this.valuesValid) {
                    this.fileName = this.fileNameValues;
                    this.displayFileTypeErrorValues = false;
                    if (this.doesReasonCodeExist('VALUS')) {
                        this.removeFileFromUploadArray('VALUS');
                    }
                    this.fileToUpload.push(new FileUploadObjectModel('VALUS', this.fileToUploadValues));
                    this.displayFileTypeErrorValues = false;
                    this.showExclamationMark_P3 = false;
                    this.showGreenTickIcon_P3 = true;
                }
                else {
                    this.validateFiles = true;
                    this.showExclamationMark_P3 = true;
                    this.showGreenTickIcon_P3 = false;
                    this.displayFileTypeErrorValues = true;
                    this.displayFileSizeErrorValues = false;
                }
            }
            else {
                this.showExclamationMark_P3 = true;
                this.showGreenTickIcon_P3 = false;
                this.displayFileSizeErrorValues = true;
                this.displayFileTypeErrorValues = false;
            }
        }
        else if (val === "pfexp") {
            if (event.target.files) {
                var filesAmount = event.target.files.length;
                for (var i = 0; i < filesAmount; i++) {
                    if (this.tempPfexp.length < 5) {
                        this.tempPfexp.push(event.target.files[i]);
                    }
                }
            }
            if (UiMode) {
                this.reasonCodeForm.get('file_pfexp').setValue(event.target.files.item(0));
            }
            this.fileToUploadPfexp = this.reasonCodeForm.get('file_pfexp').value;
            this.fileNamePfexp = this.fileToUploadPfexp.name;
            var isSizeValid = this.commonMethodUtilityService.validateFileSize(this.fileToUploadPfexp);
            var isFileTypeValid = this.commonMethodUtilityService.validateFileType(this.fileToUploadPfexp);
            this.pfexpValid = isFileTypeValid;
            if (isSizeValid) {
                this.displayFileSizeErrorPfexp = false;
                if (this.pfexpValid) {
                    this.fileName = this.fileNamePfexp;
                    this.displayFileTypeErrorPfexp = false;
                    if (this.doesReasonCodeExist('PFEXP')) {
                        this.removeFileFromUploadArray('PFEXP');
                    }
                    this.fileToUpload.push(new FileUploadObjectModel('PFEXP', this.fileToUploadPfexp));
                    this.displayFileTypeErrorPfexp = false;
                    this.showExclamationMark_P6 = false;
                    this.showGreenTickIcon_P6 = true;
                }
                else {
                    this.validateFiles = true;
                    this.showExclamationMark_P6 = true;
                    this.showGreenTickIcon_P6 = false;
                    this.displayFileTypeErrorPfexp = true;
                    this.displayFileSizeErrorPfexp = false;
                }
            }
            else {
                this.showExclamationMark_P6 = true;
                this.showGreenTickIcon_P6 = false;
                this.displayFileSizeErrorPfexp = true;
                this.displayFileTypeErrorPfexp = false;
            }
        }
        else if (val === "invms") {
            if (event.target.files) {
                var filesAmount = event.target.files.length;
                for (var i = 0; i < filesAmount; i++) {
                    if (this.tempInvms.length < 5) {
                        this.tempInvms.push(event.target.files[i]);
                    }
                }
            }
            if (UiMode) {
                this.reasonCodeForm.get('file_invms').setValue(event.target.files.item(0));
            }
            this.fileToUploadInvms = this.reasonCodeForm.get('file_invms').value;
            this.fileNameInvms = this.fileToUploadInvms.name;
            var isSizeValid = this.commonMethodUtilityService.validateFileSize(this.fileToUploadInvms);
            var isFileTypeValid = this.commonMethodUtilityService.validateFileType(this.fileToUploadInvms);
            this.invmsValid = isFileTypeValid;
            if (isSizeValid) {
                this.displayFileSizeErrorInvms = false;
                if (this.invmsValid) {
                    this.fileName = this.fileNameInvms;
                    this.displayFileTypeErrorInvms = false;
                    if (this.doesReasonCodeExist('INVMS')) {
                        this.removeFileFromUploadArray('INVMS');
                    }
                    this.fileToUpload.push(new FileUploadObjectModel('INVMS', this.fileToUploadInvms));
                    this.displayFileTypeErrorInvms = false;
                    this.showExclamationMark_P7 = false;
                    this.showGreenTickIcon_P7 = true;
                }
                else {
                    this.validateFiles = true;
                    this.showExclamationMark_P7 = true;
                    this.showGreenTickIcon_P7 = false;
                    this.displayFileTypeErrorInvms = true;
                    this.displayFileSizeErrorInvms = false;
                }
            }
            else {
                this.showExclamationMark_P7 = true;
                this.showGreenTickIcon_P7 = false;
                this.displayFileSizeErrorInvms = true;
                this.displayFileTypeErrorInvms = false;
            }
        }
        //INFOR
        else if (val === "infor") {
            if (event.target.files) {
                var filesAmount_1 = event.target.files.length;
                for (var i = 0; i < filesAmount_1; i++) {
                    if (this.tempInfor.length < 5) {
                        this.tempInfor.push(event.target.files[i]);
                    }
                }
            }
            if (UiMode) {
                this.reasonCodeForm.get('file_infor').setValue(event.target.files.item(0));
            }
            this.fileToUploadInfor = this.reasonCodeForm.get('file_infor').value;
            this.fileNameInfor = this.fileToUploadInfor.name;
            var isSizeValid = this.commonMethodUtilityService.validateFileSize(this.fileToUploadInfor);
            var isFileTypeValid = this.commonMethodUtilityService.validateFileType(this.fileToUploadInfor);
            this.inforValid = isFileTypeValid;
            if (isSizeValid) {
                this.displayFileSizeErrorInfor = false;
                if (this.inforValid) {
                    this.fileName = this.fileNameInfor;
                    this.displayFileSizeErrorInfor = false;
                    if (this.doesReasonCodeExist('INFOR')) {
                        this.removeFileFromUploadArray('INFOR');
                    }
                    this.fileToUpload.push(new FileUploadObjectModel('INFOR', this.fileToUploadInfor));
                    this.displayFileSizeErrorInfor = false;
                    this.showExclamationMark_P13 = false;
                    this.showGreenTickIcon_P13 = true;
                }
                else {
                    this.validateFiles = true;
                    this.showExclamationMark_P13 = true;
                    this.showGreenTickIcon_P13 = false;
                    this.displayFileTypeErrorInfor = true;
                    this.displayFileSizeErrorInfor = false;
                }
            }
            else {
                this.showExclamationMark_P13 = true;
                this.showGreenTickIcon_P13 = false;
                this.displayFileSizeErrorInfor = true;
                this.displayFileTypeErrorInfor = false;
            }
        }
        //INFOR
        else if (val === "gnric") {
            if (event.target.files) {
                var filesAmount = event.target.files.length;
                for (var i = 0; i < filesAmount; i++) {
                    if (this.tempGnric.length < 5) {
                        this.tempGnric.push(event.target.files[i]);
                    }
                }
            }
            if (UiMode) {
                this.reasonCodeForm.get('file_gnric').setValue(event.target.files.item(0));
            }
            this.fileToUploadGnric = this.reasonCodeForm.get('file_gnric').value;
            this.fileNameGnric = this.fileToUploadGnric.name;
            var isSizeValid = this.commonMethodUtilityService.validateFileSize(this.fileToUploadGnric);
            var isFileTypeValid = this.commonMethodUtilityService.validateFileType(this.fileToUploadGnric);
            this.gnricValid = isFileTypeValid;
            if (isSizeValid) {
                this.displayFileSizeErrorGnric = false;
                if (this.gnricValid) {
                    this.fileName = this.fileNameGnric;
                    this.displayFileTypeErrorGnric = false;
                    if (this.doesReasonCodeExist('GNRIC')) {
                        this.removeFileFromUploadArray('GNRIC');
                    }
                    this.fileToUpload.push(new FileUploadObjectModel('GNRIC', this.fileToUploadGnric));
                    this.displayFileTypeErrorGnric = false;
                    this.showExclamationMark_P8 = false;
                    this.showGreenTickIcon_P8 = true;
                }
                else {
                    this.validateFiles = true;
                    this.showExclamationMark_P8 = true;
                    this.showGreenTickIcon_P8 = false;
                    this.displayFileTypeErrorGnric = true;
                    this.displayFileSizeErrorGnric = false;
                }
            }
            else {
                this.showExclamationMark_P8 = true;
                this.showGreenTickIcon_P8 = false;
                this.displayFileSizeErrorGnric = true;
                this.displayFileTypeErrorGnric = false;
            }
        }
        //new reason-code POA//
        else if (val === "poa") {
            if (event.target.files) {
                var filesAmount = event.target.files.length;
                for (var i = 0; i < filesAmount; i++) {
                    if (this.tempPoa.length < 5) {
                        this.tempPoa.push(event.target.files[i]);
                    }
                }
            }
            if (UiMode) {
                this.reasonCodeForm.get('file_poa').setValue(event.target.files.item(0));
            }
            this.fileToUploadPoa = this.reasonCodeForm.get('file_poa').value;
            this.fileNamePoa = this.fileToUploadPoa.name;
            var isSizeValid = this.commonMethodUtilityService.validateFileSize(this.fileToUploadPoa);
            var isFileTypeValid = this.commonMethodUtilityService.validateFileType(this.fileToUploadPoa);
            this.poaValid = isFileTypeValid;
            if (isSizeValid) {
                this.displayFileSizeErrorPoa = false;
                if (this.poaValid) {
                    this.fileName = this.fileNamePoa;
                    this.displayFileTypeErrorPoa = false;
                    if (this.doesReasonCodeExist('POA')) {
                        this.removeFileFromUploadArray('POA');
                    }
                    this.fileToUpload.push(new FileUploadObjectModel('POA', this.fileToUploadPoa));
                    this.displayFileTypeErrorPoa = false;
                    this.displayFileSizeErrorPoa = false;
                    this.showExclamationMark_P9 = false;
                    this.showGreenTickIcon_P9 = true;
                }
                else {
                    this.validateFiles = true;
                    this.showExclamationMark_P9 = true;
                    this.showGreenTickIcon_P9 = false;
                    this.displayFileTypeErrorPoa = true;
                    this.displayFileSizeErrorPoa = false;
                }
            }
            else {
                this.showExclamationMark_P9 = true;
                this.showGreenTickIcon_P9 = false;
                this.displayFileSizeErrorPoa = true;
                this.displayFileTypeErrorPoa = false;
            }
        }
        //new reason-code POA//
        else if (val === "neori") {
            if (event.target.files) {
                var filesAmount = event.target.files.length;
                for (var i = 0; i < filesAmount; i++) {
                    if (this.tempNeori.length < 5) {
                        this.tempNeori.push(event.target.files[i]);
                    }
                }
            }
            if (UiMode) {
                this.reasonCodeForm.get('file_neori').setValue(event.target.files.item(0));
            }
            this.fileToUploadNeori = this.reasonCodeForm.get('file_neori').value;
            this.fileNameNeori = this.fileToUploadNeori.name;
            var isSizeValid = this.commonMethodUtilityService.validateFileSize(this.fileToUploadNeori);
            var isFileTypeValid = this.commonMethodUtilityService.validateFileType(this.fileToUploadNeori);
            this.neoriValid = isFileTypeValid;
            if (isSizeValid) {
                this.displayFileSizeErrorNeori = false;
                if (this.neoriValid) {
                    this.fileName = this.fileNameNeori;
                    this.fileToUpload.push(new FileUploadObjectModel('EORI', this.fileToUploadNeori));
                    this.displayFileTypeErrorNeori = false;
                    this.displayFileSizeErrorNeori = false;
                    this.showExclamationMark_P10 = false;
                    this.showGreenTickIcon_P10 = true;
                }
                else {
                    this.validateFiles = true;
                    this.showExclamationMark_P10 = true;
                    this.showGreenTickIcon_P10 = false;
                    this.displayFileTypeErrorNeori = true;
                    this.displayFileSizeErrorNeori = false;
                }
            }
            else {
                this.showExclamationMark_P10 = true;
                this.showGreenTickIcon_P10 = false;
                this.displayFileSizeErrorNeori = true;
                this.displayFileTypeErrorNeori = false;
            }
        }
        //defr
        else if (val === 'defr') {
            if (event.target.files) {
                var filesAmount = event.target.files.length;
                for (var i = 0; i < filesAmount; i++) {
                    if (this.tempDefr.length < 5) {
                        this.tempDefr.push(event.target.files[i]);
                    }
                }
            }
            if (UiMode) {
                this.reasonCodeForm.get('file_defr').setValue(event.target.files.item(0));
            }
            this.fileToUploadDefr = this.reasonCodeForm.get('file_defr').value;
            this.fileNameDefr = this.fileToUploadDefr.name;
            var isSizeValid = this.commonMethodUtilityService.validateFileSize(this.fileToUploadDefr);
            var isFileTypeValid = this.commonMethodUtilityService.validateFileType(this.fileToUploadDefr);
            this.defrValid = isFileTypeValid;
            if (isSizeValid) {
                this.displayFileSizeErrorDefr = false;
                if (this.defrValid) {
                    this.fileName = this.fileNameDefr;
                    this.displayFileTypeErrorDefr = false;
                    if (this.doesReasonCodeExist('DEFR')) {
                        this.removeFileFromUploadArray('DEFR');
                    }
                    this.fileToUpload.push(new FileUploadObjectModel('DEFR', this.fileToUploadDefr));
                    this.displayFileTypeErrorDefr = false;
                    this.displayFileSizeErrorDefr = false;
                    this.showExclamationMark_P11 = false;
                    this.showGreenTickIcon_P11 = true;
                    this.validateDefrForm();
                }
                else {
                    this.validateFiles = true;
                    this.showExclamationMark_P11 = true;
                    this.showGreenTickIcon_P11 = false;
                    this.displayFileTypeErrorDefr = true;
                    this.displayFileSizeErrorDefr = false;
                }
            }
            else {
                this.showExclamationMark_P11 = true;
                this.showGreenTickIcon_P11 = false;
                this.displayFileSizeErrorDefr = true;
                this.displayFileTypeErrorDefr = false;
            }
        }
        //defr
        //iprsn
        else if (val === 'iprsn') {
            if (event.target.files) {
                var filesAmount = event.target.files.length;
                for (var i = 0; i < filesAmount; i++) {
                    if (this.tempIprsn.length < 5) {
                        this.tempIprsn.push(event.target.files[i]);
                    }
                }
            }
            if (UiMode) {
                this.reasonCodeForm.get('file_iprsn').setValue(event.target.files.item(0));
            }
            this.fileToUploadIprsn = this.reasonCodeForm.get('file_iprsn').value;
            this.fileNameIprsn = this.fileToUploadIprsn.name;
            var isSizeValid = this.commonMethodUtilityService.validateFileSize(this.fileToUploadIprsn);
            var isFileTypeValid = this.commonMethodUtilityService.validateFileType(this.fileToUploadIprsn);
            this.iprsnValid = isFileTypeValid;
            if (isSizeValid) {
                this.displayFileSizeErrorIprsn = false;
                if (this.iprsnValid) {
                    this.fileName = this.fileNameIprsn;
                    this.displayFileTypeErrorIprsn = false;
                    if (this.doesReasonCodeExist('IPRSN')) {
                        this.removeFileFromUploadArray('IPRSN');
                    }
                    this.fileToUpload.push(new FileUploadObjectModel('IPRSN', this.fileToUploadIprsn));
                    this.displayFileTypeErrorIprsn = false;
                    this.displayFileSizeErrorIprsn = false;
                    this.showExclamationMark_P12 = false;
                    this.showGreenTickIcon_P12 = true;
                    this.validateIprsnForm();
                }
                else {
                    this.validateFiles = true;
                    this.showExclamationMark_P12 = true;
                    this.showGreenTickIcon_P12 = false;
                    this.displayFileTypeErrorIprsn = true;
                    this.displayFileSizeErrorIprsn = false;
                }
            }
            else {
                this.showExclamationMark_P12 = true;
                this.showGreenTickIcon_P12 = false;
                this.displayFileSizeErrorIprsn = true;
                this.displayFileTypeErrorIprsn = false;
            }
        }
        //iprsn
        //manic
        else if (val === 'manic') {
            if (event.target.files) {
                var filesAmount = event.target.files.length;
                for (var i = 0; i < filesAmount; i++) {
                    if (this.tempManic.length < 5) {
                        this.tempManic.push(event.target.files[i]);
                    }
                }
            }
            if (UiMode) {
                this.reasonCodeForm.get('file_manic').setValue(event.target.files.item(0));
            }
            this.fileToUploadManic = this.reasonCodeForm.get('file_manic').value;
            this.fileNameManic = this.fileToUploadManic.name;
            var isSizeValid = this.commonMethodUtilityService.validateFileSize(this.fileToUploadManic);
            var isFileTypeValid = this.commonMethodUtilityService.validateFileType(this.fileToUploadManic);
            this.manicValid = isFileTypeValid;
            if (isSizeValid) {
                this.displayFileSizeErrorManic = false;
                if (this.manicValid) {
                    this.fileName = this.fileNameManic;
                    this.displayFileTypeErrorManic = false;
                    if (this.doesReasonCodeExist('MANIC')) {
                        this.removeFileFromUploadArray('MANIC');
                    }
                    this.fileToUpload.push(new FileUploadObjectModel('MANIC', this.fileToUploadManic));
                    this.displayFileTypeErrorManic = false;
                    this.displayFileSizeErrorManic = false;
                    this.showExclamationMark_P14 = false;
                    this.showGreenTickIcon_P14 = true;
                    this.validateManicForm();
                }
                else {
                    this.validateFiles = true;
                    this.showExclamationMark_P14 = true;
                    this.showGreenTickIcon_P14 = false;
                    this.displayFileTypeErrorManic = true;
                    this.displayFileSizeErrorManic = false;
                }
            }
            else {
                this.showExclamationMark_P14 = true;
                this.showGreenTickIcon_P14 = false;
                this.displayFileSizeErrorManic = true;
                this.displayFileTypeErrorManic = false;
            }
        }
        //manic
        else if (val === 'impno') {
            if (event.target.files) {
                var filesAmount = event.target.files.length;
                for (var i = 0; i < filesAmount; i++) {
                    if (this.tempImpno.length < 5) {
                        this.tempImpno.push(event.target.files[i]);
                    }
                }
            }
            if (UiMode) {
                this.reasonCodeForm.get('file_impno').setValue(event.target.files.item(0));
            }
            this.fileToUploadImpno = this.reasonCodeForm.get('file_impno').value;
            this.fileNameImpno = this.fileToUploadImpno.name;
            var isSizeValid = this.commonMethodUtilityService.validateFileSize(this.fileToUploadImpno);
            var isFileTypeValid = this.commonMethodUtilityService.validateFileType(this.fileToUploadImpno);
            this.impnoValid = isFileTypeValid;
            if (isSizeValid) {
                this.displayFileSizeErrorImpno = false;
                if (this.impnoValid) {
                    this.fileName = this.fileNameImpno;
                    this.displayFileTypeErrorImpno = false;
                    if (this.doesReasonCodeExist('IMPNO')) {
                        this.removeFileFromUploadArray('IMPNO');
                    }
                    this.fileToUpload.push(new FileUploadObjectModel('IMPNO', this.fileToUploadImpno));
                    this.displayFileTypeErrorImpno = false;
                    this.displayFileSizeErrorImpno = false;
                    this.showExclamationMark_P1 = false;
                    this.showGreenTickIcon_P1 = true;
                }
                else {
                    this.validateFiles = true;
                    this.showExclamationMark_P1 = true;
                    this.showGreenTickIcon_P1 = false;
                    this.displayFileTypeErrorImpno = true;
                    this.displayFileSizeErrorImpno = false;
                }
            }
            else {
                this.showExclamationMark_P1 = true;
                this.showGreenTickIcon_P1 = false;
                this.displayFileSizeErrorImpno = true;
                this.displayFileTypeErrorImpno = false;
            }
        }
        else if (val === 'impno') {
            if (event.target.files) {
                var filesAmount = event.target.files.length;
                for (var i = 0; i < filesAmount; i++) {
                    if (this.tempImpnoPH.length < 5) {
                        this.tempImpnoPH.push(event.target.files[i]);
                    }
                }
            }
            if (UiMode) {
                this.reasonCodeForm.get('file_impno').setValue(event.target.files.item(0));
            }
            this.fileToUploadImpno = this.reasonCodeForm.get('file_impno').value;
            this.fileNameImpno = this.fileToUploadImpno.name;
            var isSizeValid = this.commonMethodUtilityService.validateFileSize(this.fileToUploadImpno);
            var isFileTypeValid = this.commonMethodUtilityService.validateFileType(this.fileToUploadImpno);
            this.impnoValid = isFileTypeValid;
            if (isSizeValid) {
                this.displayFileSizeErrorImpno = false;
                if (this.impnoValid) {
                    this.fileName = this.fileNameImpno;
                    this.displayFileTypeErrorImpno = false;
                    if (this.doesReasonCodeExist('IMPNO')) {
                        this.removeFileFromUploadArray('IMPNO');
                    }
                    this.fileToUpload.push(new FileUploadObjectModel('IMPNO', this.fileToUploadImpno));
                    this.displayFileTypeErrorImpno = false;
                    this.displayFileSizeErrorImpno = false;
                    this.showExclamationMark_P5 = false;
                    this.showGreenTickIcon_P5 = true;
                }
                else {
                    this.validateFiles = true;
                    this.showExclamationMark_P5 = true;
                    this.showGreenTickIcon_P5 = false;
                    this.displayFileTypeErrorImpno = true;
                    this.displayFileSizeErrorImpno = false;
                }
            }
            else {
                this.showExclamationMark_P5 = true;
                this.showGreenTickIcon_P5 = false;
                this.displayFileSizeErrorImpno = true;
                this.displayFileTypeErrorImpno = false;
            }
        }
        // new common code to handle addition of files for reason code
        var reasonCode = val.toUpperCase();
        var userFilesForReasonCode;
        if (this.reasonCodeToUserFiles.has(reasonCode)) {
            userFilesForReasonCode = this.reasonCodeToUserFiles.get(reasonCode);
        }
        else {
            userFilesForReasonCode = new Array();
            this.reasonCodeToUserFiles.set(reasonCode, userFilesForReasonCode);
        }
        if (event.target.files) {
            var totalFiles = event.target.files.length;
            for (var i = 0; i < totalFiles; i++) {
                var userFile = new UserFile();
                userFile.file = event.target.files[i];
                if (!this.commonMethodUtilityService.validateFileSize(userFile.file)) {
                    userFile.fileErrors.push(FileError.InvalidSize);
                }
                if (!this.commonMethodUtilityService.validateFileType(userFile.file)) {
                    userFile.fileErrors.push(FileError.InvalidType);
                }
                userFilesForReasonCode.push(userFile);
            }
        }
    };
    CommonReasonCodeComponent.prototype.previewFile = function (code) {
        if (code === 'dufr') {
            this.fileUrl = URL.createObjectURL(this.fileToUploadDufr);
            this.openFile(this.fileToUploadDufr, this.fileUrl);
        }
        else if (code === 'values') {
            this.fileUrl = URL.createObjectURL(this.fileToUploadValues);
            this.openFile(this.fileToUploadValues, this.fileUrl);
        }
        else if (code === 'pfexp') {
            this.fileUrl = URL.createObjectURL(this.fileToUploadPfexp);
            this.openFile(this.fileToUploadPfexp, this.fileUrl);
        }
        else if (code === 'invms') {
            this.fileUrl = URL.createObjectURL(this.fileToUploadInvms);
            this.openFile(this.fileToUploadInvms, this.fileUrl);
        }
        else if (code === 'infor') {
            this.fileUrl = URL.createObjectURL(this.fileToUploadInfor);
            this.openFile(this.fileToUploadInfor, this.fileUrl);
        }
        else if (code === 'gnric') {
            this.fileUrl = URL.createObjectURL(this.fileToUploadGnric);
            this.openFile(this.fileToUploadGnric, this.fileUrl);
        }
        else if (code === 'impno') {
            this.fileUrl = URL.createObjectURL(this.fileToUploadImpno);
            this.openFile(this.fileToUploadImpno, this.fileUrl);
        }
        else if (code === 'desci') {
            this.fileUrl = URL.createObjectURL(this.fileToUploadDesci);
            this.openFile(this.fileToUploadDesci, this.fileUrl);
        }
        //new reason-code POA//
        else if (code === 'poa') {
            this.fileUrl = URL.createObjectURL(this.fileToUploadPoa);
            this.openFile(this.fileToUploadPoa, this.fileUrl);
        }
        //new reason-code POA//
        else if (code === 'neori') {
            this.fileUrl = URL.createObjectURL(this.fileToUploadNeori);
            this.openFile(this.fileToUploadNeori, this.fileUrl);
        }
    };
    CommonReasonCodeComponent.prototype.openFile = function (fileToPreview, fileURL) {
        var blob;
        if (fileURL || fileURL != null) {
            if (window.navigator.msSaveOrOpenBlob) {
                blob = fileToPreview;
                window.navigator.msSaveOrOpenBlob(blob, fileToPreview.name);
            }
            else {
                window.open(fileURL, '_blank');
            }
        }
    };
    CommonReasonCodeComponent.prototype.removeFileFromUploadArray = function (reasonCode) {
        this.arrayFileSrc = new Array();
        this.arrayFileName = new Array();
        for (var index = 0; index < this.temp.length; index++) {
            if (this.temp[index].reasonCode != reasonCode) {
                this.temp.push(this.arrayFileSrc[index]);
                this.temp.push(this.arrayFileName[index]);
            }
        }
        this.temp = this.arrayFileSrc.slice();
        this.temp = this.arrayFileName.slice();
    };
    CommonReasonCodeComponent.prototype.removeFile = function (code, index) {
        if (code === 'dufr') {
            if (this.dufrValid) {
                this.tempDufrPH.splice(index, 1);
                this.removeFileFromUploadArray('DUFR');
                this.validateFiles = false;
                this.displayFileSizeErrorDufr = false;
            }
            else {
                this.tempDufrPH.splice(index, 1);
                this.removeFileFromUploadArray('DUFR');
                this.displayFileTypeErrorDufr = false;
                this.displayFileSizeErrorDufr = false;
                this.validateFiles = false;
                this.dufrValid = true;
            }
        }
        else if (code === 'defr') {
            if (this.defrValid) {
                this.tempDufrPH.splice(index, 1);
                this.removeFileFromUploadArray('DEFR');
                this.validateFiles = false;
                this.displayFileSizeErrorDefr = false;
            }
            else {
                this.tempDefr.splice(index, 1);
                this.removeFileFromUploadArray('DEFR');
                this.displayFileTypeErrorDefr = false;
                this.displayFileSizeErrorDefr = false;
                this.validateFiles = false;
                this.defrValid = true;
            }
        }
        else if (code === 'iprsn') {
            if (this.iprsnValid) {
                this.tempIprsn.splice(index, 1);
                this.removeFileFromUploadArray('IPRSN');
                this.validateFiles = false;
                this.displayFileSizeErrorIprsn = false;
            }
            else {
                this.tempIprsn.splice(index, 1);
                this.removeFileFromUploadArray('IPRSN');
                this.displayFileTypeErrorIprsn = false;
                this.displayFileSizeErrorIprsn = false;
                this.validateFiles = false;
                this.iprsnValid = true;
            }
        }
        else if (code === 'manic') {
            if (this.manicValid) {
                this.tempManic.splice(index, 1);
                this.removeFileFromUploadArray('MANIC');
                this.validateFiles = false;
                this.displayFileSizeErrorManic = false;
            }
            else {
                this.tempManic.splice(index, 1);
                this.removeFileFromUploadArray('MANIC');
                this.displayFileTypeErrorManic = false;
                this.displayFileSizeErrorManic = false;
                this.validateFiles = false;
                this.defrValid = true;
            }
        }
        else if (code === 'desci') {
            if (this.desciValid) {
                this.tempDesci.splice(index, 1);
                this.removeFileFromUploadArray('DESCI');
                this.validateFiles = false;
                this.displayFileSizeErrorDesci = false;
            }
            else {
                this.tempDesci.splice(index, 1);
                this.removeFileFromUploadArray('DESCI');
                this.displayFileTypeErrorDesci = false;
                this.displayFileSizeErrorDesci = false;
                this.validateFiles = false;
                this.desciValid = true;
            }
        }
        else if (code === 'values') {
            if (this.valuesValid) {
                this.tempValus.splice(index, 1);
                this.removeFileFromUploadArray('VALUS');
                this.validateFiles = false;
                this.displayFileSizeErrorValues = false;
            }
            else {
                this.tempValus.splice(index, 1);
                this.removeFileFromUploadArray('VALUS');
                this.displayFileTypeErrorValues = false;
                this.displayFileSizeErrorValues = false;
                this.validateFiles = false;
                this.valuesValid = true;
            }
        }
        else if (code === 'pfexp') {
            if (this.pfexpValid) {
                this.tempPfexp.splice(index, 1);
                this.removeFileFromUploadArray('PFEXP');
                this.validateFiles = false;
                this.displayFileSizeErrorPfexp = false;
            }
            else {
                this.tempPfexp.splice(index, 1);
                this.removeFileFromUploadArray('PFEXP');
                this.displayFileTypeErrorPfexp = false;
                this.displayFileSizeErrorPfexp = false;
                this.validateFiles = false;
                this.pfexpValid = true;
            }
        }
        else if (code === 'invms') {
            if (this.invmsValid) {
                this.tempInvms.splice(index, 1);
                this.removeFileFromUploadArray('INVMS');
                this.validateFiles = false;
                this.displayFileSizeErrorInvms = false;
            }
            else {
                this.displayFileTypeErrorInvms = false;
                this.displayFileSizeErrorInvms = false;
                this.tempInvms.slice(index, 1);
                this.removeFileFromUploadArray('INVMS');
                this.validateFiles = false;
                this.invmsValid = true;
            }
        }
        //INFOR
        else if (code === 'infor') {
            if (this.inforValid) {
                this.tempInfor.splice(index, 1);
                this.removeFileFromUploadArray('INFOR');
                this.validateFiles = false;
                this.displayFileSizeErrorInfor = false;
            }
            else {
                this.displayFileTypeErrorInfor = false;
                this.displayFileSizeErrorInfor = false;
                this.tempInfor.slice(index, 1);
                this.removeFileFromUploadArray('INFOR');
                this.validateFiles = false;
                this.inforValid = true;
            }
        }
        //INFOR
        else if (code === 'gnric') {
            if (this.gnricValid) {
                this.tempGnric.splice(index, 1);
                this.removeFileFromUploadArray('GNRIC');
                this.validateFiles = false;
                this.displayFileSizeErrorGnric = false;
            }
            else {
                this.displayFileTypeErrorGnric = false;
                this.displayFileSizeErrorGnric = false;
                this.tempGnric.slice(index, 1);
                this.removeFileFromUploadArray('GNRIC');
                this.validateFiles = false;
                this.gnricValid = true;
            }
        }
        else if (code === 'impno' && this.country === 'PH') {
            if (this.impnoValid) {
                this.tempImpnoPH.splice(index, 1);
                this.removeFileFromUploadArray(CommonReasonCodeComponent.REASON_CODE_IMPNO);
                this.validateFiles = false;
                this.displayFileSizeErrorImpno = false;
            }
            else {
                this.displayFileTypeErrorImpno = false;
                this.displayFileSizeErrorImpno = false;
                this.tempImpnoPH.slice(index, 1);
                this.removeFileFromUploadArray(CommonReasonCodeComponent.REASON_CODE_IMPNO);
                this.validateFiles = false;
                this.impnoValid = true;
            }
        }
        else if ((code === 'impno')) {
            if (this.impnoValid) {
                this.tempImpno.splice(index, 1);
                this.removeFileFromUploadArray(CommonReasonCodeComponent.REASON_CODE_IMPNO);
                this.validateFiles = false;
                this.displayFileSizeErrorImpno = false;
            }
            else {
                this.tempImpno.splice(index, 1);
                this.removeFileFromUploadArray(CommonReasonCodeComponent.REASON_CODE_IMPNO);
                this.displayFileTypeErrorImpno = false;
                this.displayFileSizeErrorImpno = false;
                this.validateFiles = false;
                this.impnoValid = true;
            }
        }
        //new reason-code POA//
        else if (code === 'poa') {
            if (this.poaValid) {
                this.tempPoa.splice(index, 1);
                this.validateFiles = false;
                this.displayFileSizeErrorPoa = false;
                this.removeFileFromUploadArray('POA');
            }
            else {
                // this.tempPoa.pop()
                this.tempPoa.splice(index, 1);
                this.removeFileFromUploadArray('POA');
                this.displayFileTypeErrorPoa = false;
                this.displayFileSizeErrorPoa = false;
                this.validateFiles = false;
                this.poaValid = true;
            }
        }
        //new reason-code POA//
        else if (code === 'neori') {
            if (this.neoriValid) {
                this.tempNeori.splice(index, 1);
                this.validateFiles = false;
                this.displayFileSizeErrorNeori = false;
                this.removeFileFromUploadArray('EORI');
            }
            else {
                this.tempNeori.splice(index, 1);
                this.removeFileFromUploadArray('EORI');
                this.displayFileTypeErrorNeori = false;
                this.displayFileSizeErrorNeori = false;
                this.validateFiles = false;
                this.neoriValid = true;
            }
        }
        this.fileUrl = "";
        // new common code to handle deletion of files for a reason code
        var reasonCode = code.toUpperCase();
        if (this.reasonCodeToUserFiles.has(reasonCode)) {
            var userFilesForReasonCode = this.reasonCodeToUserFiles.get(reasonCode);
            userFilesForReasonCode.splice(index, 1);
        }
    };
    /**
     * Call the translate method to get the local language version of 'POA-CONTENT'
     */
    CommonReasonCodeComponent.prototype.getPoaContent = function () {
        this.poaContent = this.translatePipe.transform('POA-CONTENT');
        return this.poaContent;
    };
    CommonReasonCodeComponent.prototype.getPfexpContent = function () {
        this.pfexpContent = this.translatePipe.transform('PFEXP_PARA_2');
        return this.pfexpContent;
    };
    CommonReasonCodeComponent.prototype.downloadDEPOATemplate = function () {
        saveAs("./assets/sample/DEpoa.pdf", "DEpoa.pdf");
    };
    CommonReasonCodeComponent.prototype.downloadZAPOATemplate = function () {
        saveAs("./assets/sample/FedExandTNTClearinginstruction.pdf", "FedExandTNTClearinginstruction.pdf");
    };
    CommonReasonCodeComponent.prototype.impnoPrivateCheckBoxClicked = function () {
        if (this.getReasonCodeFormControls.impnoPrivateShipmentCheckBox.value) {
            this.reasonCodeForm.controls['impnoPrivateShipmentReason'].enable();
            this.isImpnoPrivateShipment = true;
        }
        else {
            this.reasonCodeForm.controls['impnoPrivateShipmentReason'].disable();
            this.isImpnoPrivateShipment = false;
        }
    };
    CommonReasonCodeComponent.prototype.isSubmitButtonDisabled = function () {
        // if we've been forced to disable the submit button (because the user has submitted the form)
        // return form is disabled
        if (this.disableSubmitButton) {
            return true;
        }
        // this.validateFiles is undefined = so why was it being checked?
        // let isFormValid: boolean = this.validateFiles || this.disableSubmitBtn();
        var isFormValid = this.disableSubmitBtn();
        return isFormValid;
    };
    CommonReasonCodeComponent.prototype.disableSubmit = function () {
        this.disableSubmitButton = true;
    };
    CommonReasonCodeComponent.prototype.enableSubmit = function () {
        this.disableSubmitButton = false;
    };
    CommonReasonCodeComponent.prototype.isCustomerNamePopulated = function () {
        if (this.getReasonCodeFormControls.custName.value) {
            return true;
        }
        // hmm - customer name is not populated.. :(
        this.showFeedbackMsg = true;
        this.customLoader = false;
        this.feedbackMsg = this.translatePipe.transform('CUST_NAME_NOT_FILLED_MSG');
        return false;
    };
    CommonReasonCodeComponent.prototype.anyStringsArePopulated = function (objects) {
        for (var _i = 0, objects_1 = objects; _i < objects_1.length; _i++) {
            var element = objects_1[_i];
            if (element !== undefined && element.length > 0) {
                return true;
            }
        }
        return false;
    };
    CommonReasonCodeComponent.prototype.allStringsArePopulated = function (objects) {
        for (var _i = 0, objects_2 = objects; _i < objects_2.length; _i++) {
            var element = objects_2[_i];
            if (element === undefined || element.length < 1) {
                return false;
            }
        }
        return true;
    };
    CommonReasonCodeComponent.prototype.showReasonCodeBody = function () {
        var showBody = (this.PANEL1_CON_IMPNO_BOL ||
            this.PANEL2_CST_DESCI_BOL ||
            this.PANEL3_CNF_VALUS_BOL ||
            this.PANEL4_DUFR_BOL ||
            this.PANEL5_COR_IMPNO_BOL ||
            this.PANEL6_EXP_BOL ||
            this.PANEL7_INVMS_BOL ||
            this.PANEL8_GNRIC_BOL ||
            this.PANEL9_POA_BOL ||
            this.PANEL10_NEORI_BOL ||
            this.PANEL11_CON_DEFR_BOL ||
            this.PANEL12_CON_IPRSN_BOL ||
            this.PANEL13_INFOR_BOL ||
            this.PANEL14_CON_MANIC_BOL);
        this.showingReasonCodes = showBody;
        return this.showingReasonCodes;
    };
    CommonReasonCodeComponent.prototype.initializeReasonCodeStatuses = function (reasonCodes) {
        var _this = this;
        reasonCodes.forEach(function (reasonCode) {
            var code = reasonCode['reason-code'];
            var status = _this.mapToReasonCodeStatus(reasonCode.status);
            _this.reasonCodeToStatus.set(code, status);
            if (_this.isWorkPending) {
                _this.pendingReasonCodes.push(code);
            }
        });
    };
    CommonReasonCodeComponent.prototype.mapToReasonCodeStatus = function (status) {
        switch (status) {
            case 'INPROGRESS':
            case 'NEW':
            case 'REMINDED':
                return ReasonCodeStatus.New;
            case 'EXPIRED':
            case 'RSCODEXP':
                return ReasonCodeStatus.Expired;
            case 'EXCLUDED':
            case 'SUBMITTED':
            default:
                return ReasonCodeStatus.Submitted;
        }
    };
    CommonReasonCodeComponent.prototype.isWorkPending = function (status) {
        // if status is 'New' then work is pending
        return status === ReasonCodeStatus.New;
    };
    CommonReasonCodeComponent.prototype.getReasonCodeStatusForValus = function () {
        var status = this.reasonCodeToStatus.get(CommonReasonCodeComponent.REASON_CODE_VALUS);
        // If we had prompted the user for information
        if (this.isWorkPending(status)) {
            // if the file type the user is trying to upload is in not acceptable
            if (this.displayFileTypeErrorValues || this.displayFileSizeErrorValues) {
                return ReasonCodeStatus.Error;
            }
            var comments = this.getReasonCodeFormControls.valusComments.value;
            // did the user provide us with both comments and files?
            if (comments.length > 0 && this.tempValus.length > 0) {
                return ReasonCodeStatus.Completed;
            }
        }
        return status;
    };
    CommonReasonCodeComponent.prototype.getReasonCodeStatusForDefr = function () {
        var status = this.reasonCodeToStatus.get(CommonReasonCodeComponent.REASON_CODE_DEFR);
        // If we had prompted the user for information
        if (this.isWorkPending(status)) {
            if (this.displayFileTypeErrorDefr || this.displayFileSizeErrorDefr) {
                return ReasonCodeStatus.Error;
            }
            // if the file type the user is trying to upload is in not acceptable
            var comments = this.getReasonCodeFormControls.defrComments.value;
            var accountNumber = this.getReasonCodeFormControls.accNo_defr.value;
            var customerName = this.getReasonCodeFormControls.custNameDefr.value;
            // did the user provide us with an account number, a name, comments and files?
            if (comments.length > 0 && accountNumber.length > 0 && customerName.length > 0) {
                // For country GB, we require a file upload to be present
                if (this.country === CommonReasonCodeComponent.COUNTRY_CODE_GB) {
                    if (this.tempDefr.length > 0) {
                        return ReasonCodeStatus.Completed;
                    }
                }
                else {
                    // country code is not GB, so can say form is completed
                    return ReasonCodeStatus.Completed;
                }
            }
        }
        return status;
    };
    CommonReasonCodeComponent.prototype.getReasonCodeStatusForImpno = function () {
        var status = this.reasonCodeToStatus.get(CommonReasonCodeComponent.REASON_CODE_IMPNO);
        // If we had prompted the user for information
        if (this.isWorkPending(status)) {
            // are the data elements or file elements in error
            if (this.displayFileTypeErrorImpno || this.displayFileSizeErrorImpno ||
                this.getReasonCodeFormControls.eori_impno.errors || this.getReasonCodeFormControls.vat_impno.errors) {
                return ReasonCodeStatus.Error;
            }
            // is this country eligible for private shipment and did the user select it?
            if (this.isImpnoPrivateShipmentEligible && this.isImpnoPrivateShipment) {
                // yes it is and the user selected it as so
                var privateReason = this.getReasonCodeFormControls.impnoPrivateShipmentReason.value;
                if (privateReason.length > 0) {
                    return ReasonCodeStatus.Completed;
                }
                return status;
            }
            // not private reason eligible and or it has not been selected, so check the other fields required for impno
            var comments = this.getReasonCodeFormControls.impnoCommentsNL.value;
            var eoriValue = this.getReasonCodeFormControls.eori_impno.value;
            var vatValue = this.getReasonCodeFormControls.vat_impno.value;
            // did the user provide us with a EORI, VAT, comments and files and they are not in error
            if (this.anyStringsArePopulated([comments, eoriValue, vatValue]) || this.tempImpno.length > 0) {
                return ReasonCodeStatus.Completed;
            }
        }
        return status;
    };
    CommonReasonCodeComponent.prototype.getReasonCodeStatusForIprsn = function () {
        var status = this.reasonCodeToStatus.get(CommonReasonCodeComponent.REASON_CODE_IPRSN);
        // If we had prompted the user for information
        if (this.isWorkPending(status)) {
            if (this.displayFileTypeErrorIprsn || this.displayFileSizeErrorIprsn) {
                return ReasonCodeStatus.Error;
            }
            // if the file type the user is trying to upload is in not acceptable
            var comments = this.getReasonCodeFormControls.iprsnComments.value;
            var reasonComments = this.getReasonCodeFormControls.reasonComments_iprsn.value;
            // did the user provide us with a EORI, VAT, comments and files?
            if (this.allStringsArePopulated([comments, reasonComments]) && this.tempIprsn.length > 0) {
                return ReasonCodeStatus.Completed;
            }
        }
        return status;
    };
    CommonReasonCodeComponent.prototype.getReasonCodeStatusForManic = function () {
        var status = this.reasonCodeToStatus.get(CommonReasonCodeComponent.REASON_CODE_MANIC);
        // If we had prompted the user for information
        if (this.isWorkPending(status)) {
            if (this.displayFileTypeErrorManic || this.displayFileSizeErrorManic) {
                return ReasonCodeStatus.Error;
            }
            // if the file type the user is trying to upload is in not acceptable
            var comments = this.getReasonCodeFormControls.manicComments.value;
            var reasonComments = this.getReasonCodeFormControls.reasonComments_manic.value;
            // did the user provide us with a EORI, VAT, comments and files?
            if (comments.length > 0 && reasonComments.length > 0 && this.tempManic.length > 0) {
                return ReasonCodeStatus.Completed;
            }
        }
        return status;
    };
    CommonReasonCodeComponent.prototype.getReasonCodeStatus = function (reasonCode) {
        switch (reasonCode) {
            case CommonReasonCodeComponent.REASON_CODE_DEFR:
                return this.getReasonCodeStatusForDefr();
            case CommonReasonCodeComponent.REASON_CODE_IPRSN:
                return this.getReasonCodeStatusForIprsn();
            case CommonReasonCodeComponent.REASON_CODE_IMPNO:
                return this.getReasonCodeStatusForImpno();
            case CommonReasonCodeComponent.REASON_CODE_MANIC:
                return this.getReasonCodeStatusForManic();
            case CommonReasonCodeComponent.REASON_CODE_VALUS:
                return this.getReasonCodeStatusForValus();
            case CommonReasonCodeComponent.REASON_CODE_DESCI:
            case CommonReasonCodeComponent.REASON_CODE_EORI:
            case CommonReasonCodeComponent.REASON_CODE_POA:
            default:
                return this.reasonCodeToStatus.get(reasonCode);
        }
    };
    CommonReasonCodeComponent.prototype.isReasonCodeStatusEqualTo = function (reasonCode, expectedReasonCodeStatus) {
        var reasonCodeStatus = this.getReasonCodeStatus(reasonCode);
        return reasonCodeStatus === expectedReasonCodeStatus;
    };
    /**
     * This method returns a boolean true if details for the reason code should be shown or false if not
     *
     * @param reasonCode the reason code to check
     * @returns boolean true if details for the reason code should be shown
     */
    CommonReasonCodeComponent.prototype.showReasonCode = function (reasonCode) {
        var status = this.reasonCodeToStatus.get(reasonCode);
        return status !== undefined;
    };
    /**
     * This method returns a boolean true to indicate if the form the reason code should be shown or false if not
     *
     * @param reasonCode the reason code to check
     * @returns boolean true if form for the reason code should be shown
     */
    CommonReasonCodeComponent.prototype.showReasonCodeForm = function (reasonCode) {
        var status = this.reasonCodeToStatus.get(reasonCode);
        return this.statusesToDisplayFormOn.has(status);
    };
    CommonReasonCodeComponent.prototype.isReasonCodeStatusCompleted = function (reasonCode) {
        return this.isReasonCodeStatusEqualTo(reasonCode, ReasonCodeStatus.Completed);
    };
    CommonReasonCodeComponent.prototype.isReasonCodeStatusError = function (reasonCode) {
        return this.isReasonCodeStatusEqualTo(reasonCode, ReasonCodeStatus.Error);
    };
    CommonReasonCodeComponent.prototype.isReasonCodeStatusNew = function (reasonCode) {
        return this.isReasonCodeStatusEqualTo(reasonCode, ReasonCodeStatus.New);
    };
    CommonReasonCodeComponent.prototype.isReasonCodeStatusSubmitted = function (reasonCode) {
        return this.isReasonCodeStatusEqualTo(reasonCode, ReasonCodeStatus.Submitted);
    };
    /**
     * The method returns a descriptive text explaining the status of this particular reason code.
     *
     * @param reasonCode the reason code for which we wish to have a descriptive text
     * @returns a descriptive text of the reason code (in english..)
     */
    CommonReasonCodeComponent.prototype.getReasonCodeStatusDescription = function (reasonCode) {
        var reasonCodeStatus = this.getReasonCodeStatus(reasonCode);
        switch (reasonCodeStatus) {
            case ReasonCodeStatus.Submitted:
            case ReasonCodeStatus.Completed:
            case ReasonCodeStatus.Expired:
                return "completed";
            case ReasonCodeStatus.New:
                return "new";
            case ReasonCodeStatus.Error:
            default:
                return "error";
        }
    };
    /**
     * The method returns a URL to the image to be shown to the user for the selected reason code.
     *
     * @param reasonCode the url to the image to be shown
     * @returns a link to the image to display for the provided reason code
     */
    CommonReasonCodeComponent.prototype.getReasonCodeStatusImage = function (reasonCode) {
        var reasonCodeStatus = this.getReasonCodeStatus(reasonCode);
        // console.log(`For reason code ${reasonCode} status is ` + ReasonCodeStatus[reasonCodeStatus])
        switch (reasonCodeStatus) {
            case ReasonCodeStatus.Submitted:
            case ReasonCodeStatus.Completed:
            case ReasonCodeStatus.Expired:
                return "./assets/img/tick.png";
            case ReasonCodeStatus.New:
                return "./assets/img/circleG.png";
            case ReasonCodeStatus.Error:
            default:
                return "./assets/img/exclamation.png";
        }
    };
    /**
     * If at least one of the reason codes is not in submitted or expired - that is the user is going to be
     * able to fill in details, let them see the submited details div.
     * this.reasonCodeToStatus.forEach((status: ReasonCodeStatus, reasonCode: string) => {
     *   console.log(`${reasonCode} ==> ${status}` + ReasonCodeStatus.);
     * });
     */
    CommonReasonCodeComponent.prototype.checkIfUserNeedsToSubmitDetails = function () {
        var acceptedStatuses = ['SUBMITTED', 'RSCODEXP'];
        for (var _i = 0, _a = this.reasonCodeList; _i < _a.length; _i++) {
            var reasonCode = _a[_i];
            if (!acceptedStatuses.includes(reasonCode.status)) {
                this.showSubmitDetailsDiv = true;
            }
        }
    };
    CommonReasonCodeComponent.prototype.setTermsAndConditionsUrl = function (countryCode, languageCode) {
        if (countryCode === void 0) { countryCode = 'GB'; }
        if (languageCode === void 0) { languageCode = 'en'; }
        this.termsAndConditionsURL =
            window.location.href.substring(0, window.location.href.indexOf('commonReasonCode/') + 17)
                + "termsAndConditions/"
                + countryCode + "/"
                + languageCode;
    };
    // class level constants
    CommonReasonCodeComponent.REASON_CODE_MANIC = 'MANIC';
    CommonReasonCodeComponent.REASON_CODE_DEFR = 'DEFR';
    CommonReasonCodeComponent.REASON_CODE_IPRSN = 'IPRSN';
    CommonReasonCodeComponent.REASON_CODE_IMPNO = 'IMPNO';
    CommonReasonCodeComponent.REASON_CODE_INVOR = 'INVOR';
    CommonReasonCodeComponent.REASON_CODE_VALUS = 'VALUS';
    CommonReasonCodeComponent.REASON_CODE_DESCI = 'DESCI';
    CommonReasonCodeComponent.REASON_CODE_EORI = 'EORI';
    CommonReasonCodeComponent.REASON_CODE_POA = 'POA';
    CommonReasonCodeComponent.COUNTRY_CODE_GB = 'GB';
    CommonReasonCodeComponent.RC_CODE = 'rc_code';
    CommonReasonCodeComponent.DETAILS = 'details';
    return CommonReasonCodeComponent;
}());
export { CommonReasonCodeComponent };
